// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/billing.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { PaginationRequest, PaginationResponse } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { DateRange } from "./usage_pb";
import { file_gitpod_v1_usage } from "./usage_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/billing.proto.
 */
export const file_gitpod_v1_billing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_pagination, file_gitpod_v1_usage, file_google_protobuf_timestamp]);

/**
 * @generated from message gitpod.v1.BillingRecord
 */
export type BillingRecord = Message<"gitpod.v1.BillingRecord"> & {
  /**
   * id is the unique identifier for the billing record
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.BillingRecordMetadata metadata = 2;
   */
  metadata?: BillingRecordMetadata;

  /**
   * @generated from field: gitpod.v1.BillingRecordSpec spec = 3;
   */
  spec?: BillingRecordSpec;

  /**
   * @generated from field: gitpod.v1.BillingRecordStatus status = 4;
   */
  status?: BillingRecordStatus;
};

/**
 * Describes the message gitpod.v1.BillingRecord.
 * Use `create(BillingRecordSchema)` to create a new message.
 */
export const BillingRecordSchema: GenMessage<BillingRecord> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 0);

/**
 * @generated from message gitpod.v1.BillingRecordMetadata
 */
export type BillingRecordMetadata = Message<"gitpod.v1.BillingRecordMetadata"> & {
  /**
   * organization_id is the ID of the organization that owns the record
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * realm is the billing realm (sandbox or production)
   *
   * @generated from field: gitpod.v1.BillingRealm realm = 2;
   */
  realm: BillingRealm;

  /**
   * created_at is the time the record was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is the time the record was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.BillingRecordMetadata.
 * Use `create(BillingRecordMetadataSchema)` to create a new message.
 */
export const BillingRecordMetadataSchema: GenMessage<BillingRecordMetadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 1);

/**
 * @generated from message gitpod.v1.BillingRecordSpec
 */
export type BillingRecordSpec = Message<"gitpod.v1.BillingRecordSpec"> & {
  /**
   * plan contains the plan details
   *
   * @generated from field: gitpod.v1.BillingPlanSpec plan = 1;
   */
  plan?: BillingPlanSpec;
};

/**
 * Describes the message gitpod.v1.BillingRecordSpec.
 * Use `create(BillingRecordSpecSchema)` to create a new message.
 */
export const BillingRecordSpecSchema: GenMessage<BillingRecordSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 2);

/**
 * @generated from message gitpod.v1.BillingPlanSpec
 */
export type BillingPlanSpec = Message<"gitpod.v1.BillingPlanSpec"> & {
  /**
   * kind contains the kind of plan
   *
   * @generated from field: gitpod.v1.BillingPlanKind kind = 1;
   */
  kind: BillingPlanKind;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents_usd = 2;
   */
  amountCentsUsd: bigint;

  /**
   * version contains the version of the plan
   *
   * @generated from field: string version_id = 3;
   */
  versionId: string;
};

/**
 * Describes the message gitpod.v1.BillingPlanSpec.
 * Use `create(BillingPlanSpecSchema)` to create a new message.
 */
export const BillingPlanSpecSchema: GenMessage<BillingPlanSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 3);

/**
 * @generated from message gitpod.v1.BillingRecordStatus
 */
export type BillingRecordStatus = Message<"gitpod.v1.BillingRecordStatus"> & {
  /**
   * plan contains the plan status
   *
   * @generated from field: gitpod.v1.BillingPlanStatus plan = 1;
   */
  plan?: BillingPlanStatus;

  /**
   * card_verification contains the status of the card verification
   *
   * @generated from field: gitpod.v1.PaymentMethodVerificationStatus payment_method_verification = 2;
   */
  paymentMethodVerification?: PaymentMethodVerificationStatus;

  /**
   * credit contains the status of the credit balance
   *
   * @generated from field: gitpod.v1.CreditStatus credit = 3;
   */
  credit: CreditStatus;

  /**
   * error contains any error message
   *
   * @generated from field: string error = 4;
   */
  error: string;
};

/**
 * Describes the message gitpod.v1.BillingRecordStatus.
 * Use `create(BillingRecordStatusSchema)` to create a new message.
 */
export const BillingRecordStatusSchema: GenMessage<BillingRecordStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 4);

/**
 * @generated from message gitpod.v1.BillingPlanStatus
 */
export type BillingPlanStatus = Message<"gitpod.v1.BillingPlanStatus"> & {
  /**
   * kind contains the kind of plan
   *
   * @generated from field: gitpod.v1.BillingPlanKind kind = 1;
   */
  kind: BillingPlanKind;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents_usd = 2;
   */
  amountCentsUsd: bigint;

  /**
   * ending_at contains the date and time when the plan ends
   *
   * @generated from field: google.protobuf.Timestamp ending_at = 3;
   */
  endingAt?: Timestamp;

  /**
   * version contains the version of the plan
   *
   * @generated from field: string version_id = 4;
   */
  versionId: string;
};

/**
 * Describes the message gitpod.v1.BillingPlanStatus.
 * Use `create(BillingPlanStatusSchema)` to create a new message.
 */
export const BillingPlanStatusSchema: GenMessage<BillingPlanStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 5);

/**
 * @generated from message gitpod.v1.PaymentMethodVerificationStatus
 */
export type PaymentMethodVerificationStatus = Message<"gitpod.v1.PaymentMethodVerificationStatus"> & {
  /**
   * status contains the status of the card verification
   *
   * @generated from field: gitpod.v1.CreditCardVerificationStatus card_verification_status = 1;
   */
  cardVerificationStatus: CreditCardVerificationStatus;

  /**
   * error contains any error message
   *
   * @generated from field: string error = 2;
   */
  error: string;
};

/**
 * Describes the message gitpod.v1.PaymentMethodVerificationStatus.
 * Use `create(PaymentMethodVerificationStatusSchema)` to create a new message.
 */
export const PaymentMethodVerificationStatusSchema: GenMessage<PaymentMethodVerificationStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 6);

/**
 * @generated from message gitpod.v1.GetBillingRecordRequest
 */
export type GetBillingRecordRequest = Message<"gitpod.v1.GetBillingRecordRequest"> & {
  /**
   * billing_record_id specifies the billing record identifier
   *
   * @generated from field: string billing_record_id = 1;
   */
  billingRecordId: string;
};

/**
 * Describes the message gitpod.v1.GetBillingRecordRequest.
 * Use `create(GetBillingRecordRequestSchema)` to create a new message.
 */
export const GetBillingRecordRequestSchema: GenMessage<GetBillingRecordRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 7);

/**
 * @generated from message gitpod.v1.GetBillingRecordResponse
 */
export type GetBillingRecordResponse = Message<"gitpod.v1.GetBillingRecordResponse"> & {
  /**
   * @generated from field: gitpod.v1.BillingRecord billing_record = 1;
   */
  billingRecord?: BillingRecord;
};

/**
 * Describes the message gitpod.v1.GetBillingRecordResponse.
 * Use `create(GetBillingRecordResponseSchema)` to create a new message.
 */
export const GetBillingRecordResponseSchema: GenMessage<GetBillingRecordResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 8);

/**
 * @generated from message gitpod.v1.UpdateBillingRecordRequest
 */
export type UpdateBillingRecordRequest = Message<"gitpod.v1.UpdateBillingRecordRequest"> & {
  /**
   * billing_record_id is the ID of the billing record to update
   *
   * @generated from field: string billing_record_id = 1;
   */
  billingRecordId: string;

  /**
   * kind contains the kind of plan
   *
   * @generated from field: optional gitpod.v1.BillingPlanKind kind = 2;
   */
  kind?: BillingPlanKind;

  /**
   * amount_cents contains the amount of cents to charge the organization
   *
   * @generated from field: optional int64 amount_cents_usd = 3;
   */
  amountCentsUsd?: bigint;
};

/**
 * Describes the message gitpod.v1.UpdateBillingRecordRequest.
 * Use `create(UpdateBillingRecordRequestSchema)` to create a new message.
 */
export const UpdateBillingRecordRequestSchema: GenMessage<UpdateBillingRecordRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 9);

/**
 * @generated from message gitpod.v1.UpdateBillingRecordResponse
 */
export type UpdateBillingRecordResponse = Message<"gitpod.v1.UpdateBillingRecordResponse"> & {
};

/**
 * Describes the message gitpod.v1.UpdateBillingRecordResponse.
 * Use `create(UpdateBillingRecordResponseSchema)` to create a new message.
 */
export const UpdateBillingRecordResponseSchema: GenMessage<UpdateBillingRecordResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 10);

/**
 * @generated from message gitpod.v1.SetupBillingRequest
 */
export type SetupBillingRequest = Message<"gitpod.v1.SetupBillingRequest"> & {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.SetupBillingRequest.
 * Use `create(SetupBillingRequestSchema)` to create a new message.
 */
export const SetupBillingRequestSchema: GenMessage<SetupBillingRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 11);

/**
 * @generated from message gitpod.v1.SetupBillingResponse
 */
export type SetupBillingResponse = Message<"gitpod.v1.SetupBillingResponse"> & {
  /**
   * setup_intent_client_secret is the client secret for the Stripe SetupIntent
   *
   * @generated from field: string setup_intent_client_secret = 1;
   */
  setupIntentClientSecret: string;

  /**
   * customer_session_client_secret is the client secret for the Stripe CustomerSession
   *
   * @generated from field: string customer_session_client_secret = 2;
   */
  customerSessionClientSecret: string;
};

/**
 * Describes the message gitpod.v1.SetupBillingResponse.
 * Use `create(SetupBillingResponseSchema)` to create a new message.
 */
export const SetupBillingResponseSchema: GenMessage<SetupBillingResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 12);

/**
 * @generated from message gitpod.v1.CompleteBillingSetupRequest
 */
export type CompleteBillingSetupRequest = Message<"gitpod.v1.CompleteBillingSetupRequest"> & {
  /**
   * organization_id is the ID of the organization to complete billing setup for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * setup_intent_id is the Stripe SetupIntent ID to verify completion
   *
   * @generated from field: string setup_intent_id = 2;
   */
  setupIntentId: string;
};

/**
 * Describes the message gitpod.v1.CompleteBillingSetupRequest.
 * Use `create(CompleteBillingSetupRequestSchema)` to create a new message.
 */
export const CompleteBillingSetupRequestSchema: GenMessage<CompleteBillingSetupRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 13);

/**
 * @generated from message gitpod.v1.CompleteBillingSetupResponse
 */
export type CompleteBillingSetupResponse = Message<"gitpod.v1.CompleteBillingSetupResponse"> & {
  /**
   * contract_id is the Metronome contract ID created for the organization
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * trial_granted indicates whether a free trial was successfully granted
   *
   * @generated from field: bool trial_granted = 2;
   */
  trialGranted: boolean;

  /**
   * trial_amount_credits is the amount of trial credits granted in Gitpod Credits
   *
   * @generated from field: double trial_amount_credits = 3;
   */
  trialAmountCredits: number;

  /**
   * trial_expires_at is when the trial credits expire
   *
   * @generated from field: google.protobuf.Timestamp trial_expires_at = 4;
   */
  trialExpiresAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.CompleteBillingSetupResponse.
 * Use `create(CompleteBillingSetupResponseSchema)` to create a new message.
 */
export const CompleteBillingSetupResponseSchema: GenMessage<CompleteBillingSetupResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 14);

/**
 * @generated from message gitpod.v1.GetBillingInfoRequest
 */
export type GetBillingInfoRequest = Message<"gitpod.v1.GetBillingInfoRequest"> & {
  /**
   * organization_id is the ID of the organization to get billing info for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetBillingInfoRequest.
 * Use `create(GetBillingInfoRequestSchema)` to create a new message.
 */
export const GetBillingInfoRequestSchema: GenMessage<GetBillingInfoRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 15);

/**
 * @generated from message gitpod.v1.GetBillingInfoResponse
 */
export type GetBillingInfoResponse = Message<"gitpod.v1.GetBillingInfoResponse"> & {
  /**
   * total_credits is the total amount of credits granted to the organization
   *
   * @generated from field: double total_credits = 1;
   */
  totalCredits: number;

  /**
   * available_credits is the remaining credits available for use
   *
   * @generated from field: double available_credits = 2;
   */
  availableCredits: number;

  /**
   * used_credits is the amount of credits already consumed
   *
   * @generated from field: double used_credits = 3;
   */
  usedCredits: number;

  /**
   * payment_method_status indicates the status of the payment method
   *
   * @generated from field: gitpod.v1.PaymentMethodStatus payment_method_status = 5;
   */
  paymentMethodStatus: PaymentMethodStatus;

  /**
   * credit_status indicates the status of the credit balance
   *
   * @generated from field: gitpod.v1.CreditStatus credit_status = 6;
   */
  creditStatus: CreditStatus;

  /**
   * payment_failure contains information about payment failures if any
   *
   * @generated from field: gitpod.v1.PaymentFailureInfo payment_failure = 10;
   */
  paymentFailure?: PaymentFailureInfo;

  /**
   * topup_payment_failure contains information about topup payment failures if any
   *
   * @generated from field: gitpod.v1.TopupPaymentFailureInfo topup_payment_failure = 11;
   */
  topupPaymentFailure?: TopupPaymentFailureInfo;

  /**
   * auto_topup_settings contains the current auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings auto_topup_settings = 12;
   */
  autoTopupSettings?: AutoTopupSettings;

  /**
   * last_auto_topup_at is the timestamp of the most recent automatic top-up, if any.
   *
   * @generated from field: google.protobuf.Timestamp last_auto_topup_at = 13;
   */
  lastAutoTopupAt?: Timestamp;

  /**
   * monthly_commitment_cents is the monthly subscription amount in USD cents.
   * 0 means the organization is on a free Core plan. Only set for Core tier organizations
   * with an active contract.
   *
   * @generated from field: int64 monthly_commitment_cents = 14;
   */
  monthlyCommitmentCents: bigint;

  /**
   * recovery_credit_granted_at is set when the one-time recovery credit grant has been used.
   * Nil means the organization is still eligible for a recovery credit grant.
   *
   * @generated from field: google.protobuf.Timestamp recovery_credit_granted_at = 15;
   */
  recoveryCreditGrantedAt?: Timestamp;

  /**
   * credit_grant is the contracted credit grant for the organization, in whole credits.
   * Only set for enterprise UBB organizations. 0 means no grant has been configured.
   *
   * @generated from field: int64 credit_grant = 16;
   */
  creditGrant: bigint;
};

/**
 * Describes the message gitpod.v1.GetBillingInfoResponse.
 * Use `create(GetBillingInfoResponseSchema)` to create a new message.
 */
export const GetBillingInfoResponseSchema: GenMessage<GetBillingInfoResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 16);

/**
 * @generated from message gitpod.v1.ReconcileBillingRequest
 */
export type ReconcileBillingRequest = Message<"gitpod.v1.ReconcileBillingRequest"> & {
  /**
   * organization_id is the ID of the organization to reconcile billing for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.ReconcileBillingRequest.
 * Use `create(ReconcileBillingRequestSchema)` to create a new message.
 */
export const ReconcileBillingRequestSchema: GenMessage<ReconcileBillingRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 17);

/**
 * @generated from message gitpod.v1.ReconcileBillingResponse
 */
export type ReconcileBillingResponse = Message<"gitpod.v1.ReconcileBillingResponse"> & {
};

/**
 * Describes the message gitpod.v1.ReconcileBillingResponse.
 * Use `create(ReconcileBillingResponseSchema)` to create a new message.
 */
export const ReconcileBillingResponseSchema: GenMessage<ReconcileBillingResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 18);

/**
 * TopupPaymentFailureInfo contains information about a failed topup payment
 *
 * @generated from message gitpod.v1.TopupPaymentFailureInfo
 */
export type TopupPaymentFailureInfo = Message<"gitpod.v1.TopupPaymentFailureInfo"> & {
  /**
   * failed_at is when the topup payment failure occurred
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 1;
   */
  failedAt?: Timestamp;

  /**
   * error_message describes why the topup payment failed
   *
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;
};

/**
 * Describes the message gitpod.v1.TopupPaymentFailureInfo.
 * Use `create(TopupPaymentFailureInfoSchema)` to create a new message.
 */
export const TopupPaymentFailureInfoSchema: GenMessage<TopupPaymentFailureInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 19);

/**
 * @generated from message gitpod.v1.PaymentFailureInfo
 */
export type PaymentFailureInfo = Message<"gitpod.v1.PaymentFailureInfo"> & {
  /**
   * state indicates the current state of the payment failure
   *
   * @generated from field: gitpod.v1.PaymentFailureState state = 1;
   */
  state: PaymentFailureState;

  /**
   * grace_period_ends_at is when the grace period ends
   *
   * @generated from field: google.protobuf.Timestamp grace_period_ends_at = 2;
   */
  gracePeriodEndsAt?: Timestamp;

  /**
   * failed_at is when the payment failure occurred
   *
   * @generated from field: google.protobuf.Timestamp failed_at = 3;
   */
  failedAt?: Timestamp;

  /**
   * failure_reason describes why the payment failed
   *
   * @generated from field: string failure_reason = 4;
   */
  failureReason: string;
};

/**
 * Describes the message gitpod.v1.PaymentFailureInfo.
 * Use `create(PaymentFailureInfoSchema)` to create a new message.
 */
export const PaymentFailureInfoSchema: GenMessage<PaymentFailureInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 20);

/**
 * @generated from message gitpod.v1.CreateSubscriptionRequest
 */
export type CreateSubscriptionRequest = Message<"gitpod.v1.CreateSubscriptionRequest"> & {
  /**
   * organization_id is the ID of the organization to create subscription for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * subscription_type specifies the type of subscription to create
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 2;
   */
  subscriptionType: SubscriptionType;

  /**
   * amount_cents is the amount of cents to charge the organization
   *
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * coupon_code is the code of the coupon to apply to the subscription
   *
   * @generated from field: string coupon_code = 4;
   */
  couponCode: string;
};

/**
 * Describes the message gitpod.v1.CreateSubscriptionRequest.
 * Use `create(CreateSubscriptionRequestSchema)` to create a new message.
 */
export const CreateSubscriptionRequestSchema: GenMessage<CreateSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 21);

/**
 * @generated from message gitpod.v1.CreateSubscriptionResponse
 */
export type CreateSubscriptionResponse = Message<"gitpod.v1.CreateSubscriptionResponse"> & {
  /**
   * @generated from field: gitpod.v1.Subscription subscription = 1;
   */
  subscription?: Subscription;
};

/**
 * Describes the message gitpod.v1.CreateSubscriptionResponse.
 * Use `create(CreateSubscriptionResponseSchema)` to create a new message.
 */
export const CreateSubscriptionResponseSchema: GenMessage<CreateSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 22);

/**
 * @generated from message gitpod.v1.CancelSubscriptionRequest
 */
export type CancelSubscriptionRequest = Message<"gitpod.v1.CancelSubscriptionRequest"> & {
  /**
   * subscription_id is the ID of the subscription to cancel
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * subscription_type specifies the type of subscription to cancel
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 2;
   */
  subscriptionType: SubscriptionType;
};

/**
 * Describes the message gitpod.v1.CancelSubscriptionRequest.
 * Use `create(CancelSubscriptionRequestSchema)` to create a new message.
 */
export const CancelSubscriptionRequestSchema: GenMessage<CancelSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 23);

/**
 * @generated from message gitpod.v1.CancelSubscriptionResponse
 */
export type CancelSubscriptionResponse = Message<"gitpod.v1.CancelSubscriptionResponse"> & {
};

/**
 * Describes the message gitpod.v1.CancelSubscriptionResponse.
 * Use `create(CancelSubscriptionResponseSchema)` to create a new message.
 */
export const CancelSubscriptionResponseSchema: GenMessage<CancelSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 24);

/**
 * @generated from message gitpod.v1.UpdateSubscriptionRequest
 */
export type UpdateSubscriptionRequest = Message<"gitpod.v1.UpdateSubscriptionRequest"> & {
  /**
   * organization_id is the ID of the organization whose subscription to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * new_amount_cents is the new amount in cents to charge the organization
   *
   * @generated from field: int64 new_amount_cents = 2;
   */
  newAmountCents: bigint;
};

/**
 * Describes the message gitpod.v1.UpdateSubscriptionRequest.
 * Use `create(UpdateSubscriptionRequestSchema)` to create a new message.
 */
export const UpdateSubscriptionRequestSchema: GenMessage<UpdateSubscriptionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 25);

/**
 * @generated from message gitpod.v1.UpdateSubscriptionResponse
 */
export type UpdateSubscriptionResponse = Message<"gitpod.v1.UpdateSubscriptionResponse"> & {
  /**
   * @generated from field: gitpod.v1.Subscription subscription = 1;
   */
  subscription?: Subscription;
};

/**
 * Describes the message gitpod.v1.UpdateSubscriptionResponse.
 * Use `create(UpdateSubscriptionResponseSchema)` to create a new message.
 */
export const UpdateSubscriptionResponseSchema: GenMessage<UpdateSubscriptionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 26);

/**
 * @generated from message gitpod.v1.ListSubscriptionsRequest
 */
export type ListSubscriptionsRequest = Message<"gitpod.v1.ListSubscriptionsRequest"> & {
  /**
   * organization_id is the ID of the organization to list subscriptions for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.ListSubscriptionsRequest.
 * Use `create(ListSubscriptionsRequestSchema)` to create a new message.
 */
export const ListSubscriptionsRequestSchema: GenMessage<ListSubscriptionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 27);

/**
 * @generated from message gitpod.v1.Subscription
 */
export type Subscription = Message<"gitpod.v1.Subscription"> & {
  /**
   * contract_id is the unique identifier for the contract
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * organization_id is the ID of the organization that owns the subscription
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * subscription_type is the type of subscription
   *
   * @generated from field: gitpod.v1.SubscriptionType subscription_type = 3;
   */
  subscriptionType: SubscriptionType;

  /**
   * status is the current status of the subscription
   *
   * @generated from field: gitpod.v1.SubscriptionStatus status = 4;
   */
  status: SubscriptionStatus;

  /**
   * starts_at is when the subscription was created
   *
   * @generated from field: google.protobuf.Timestamp starts_at = 6;
   */
  startsAt?: Timestamp;

  /**
   * cancelled_at is when the subscription was cancelled (if applicable)
   *
   * @generated from field: google.protobuf.Timestamp cancelled_at = 7;
   */
  cancelledAt?: Timestamp;

  /**
   * ends_at is when the subscription access will end (if cancelled)
   *
   * @generated from field: google.protobuf.Timestamp ends_at = 9;
   */
  endsAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.Subscription.
 * Use `create(SubscriptionSchema)` to create a new message.
 */
export const SubscriptionSchema: GenMessage<Subscription> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 28);

/**
 * @generated from message gitpod.v1.ListSubscriptionsResponse
 */
export type ListSubscriptionsResponse = Message<"gitpod.v1.ListSubscriptionsResponse"> & {
  /**
   * subscriptions is the list of subscriptions for the organization
   *
   * @generated from field: repeated gitpod.v1.Subscription subscriptions = 1;
   */
  subscriptions: Subscription[];
};

/**
 * Describes the message gitpod.v1.ListSubscriptionsResponse.
 * Use `create(ListSubscriptionsResponseSchema)` to create a new message.
 */
export const ListSubscriptionsResponseSchema: GenMessage<ListSubscriptionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 29);

/**
 * @generated from message gitpod.v1.GrantCreditsRequest
 */
export type GrantCreditsRequest = Message<"gitpod.v1.GrantCreditsRequest"> & {
  /**
   * organization_id is the ID of the organization to grant credits to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * credits_amount is the amount of credits to grant (must be >= 40)
   *
   * @generated from field: double credits_amount = 2;
   */
  creditsAmount: number;
};

/**
 * Describes the message gitpod.v1.GrantCreditsRequest.
 * Use `create(GrantCreditsRequestSchema)` to create a new message.
 */
export const GrantCreditsRequestSchema: GenMessage<GrantCreditsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 30);

/**
 * @generated from message gitpod.v1.GrantCreditsResponse
 */
export type GrantCreditsResponse = Message<"gitpod.v1.GrantCreditsResponse"> & {
};

/**
 * Describes the message gitpod.v1.GrantCreditsResponse.
 * Use `create(GrantCreditsResponseSchema)` to create a new message.
 */
export const GrantCreditsResponseSchema: GenMessage<GrantCreditsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 31);

/**
 * @generated from message gitpod.v1.GetStripePublishableKeyRequest
 */
export type GetStripePublishableKeyRequest = Message<"gitpod.v1.GetStripePublishableKeyRequest"> & {
  /**
   * organization_id is the ID of the organization to get the publishable key for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetStripePublishableKeyRequest.
 * Use `create(GetStripePublishableKeyRequestSchema)` to create a new message.
 */
export const GetStripePublishableKeyRequestSchema: GenMessage<GetStripePublishableKeyRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 32);

/**
 * @generated from message gitpod.v1.GetStripePublishableKeyResponse
 */
export type GetStripePublishableKeyResponse = Message<"gitpod.v1.GetStripePublishableKeyResponse"> & {
  /**
   * publishable_key is the Stripe publishable key for the organization's billing realm
   *
   * @generated from field: string publishable_key = 1;
   */
  publishableKey: string;
};

/**
 * Describes the message gitpod.v1.GetStripePublishableKeyResponse.
 * Use `create(GetStripePublishableKeyResponseSchema)` to create a new message.
 */
export const GetStripePublishableKeyResponseSchema: GenMessage<GetStripePublishableKeyResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 33);

/**
 * @generated from message gitpod.v1.SetBillingRealmRequest
 */
export type SetBillingRealmRequest = Message<"gitpod.v1.SetBillingRealmRequest"> & {
  /**
   * organization_id is the ID of the organization to update
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * realm is the new billing realm to set for the organization
   *
   * @generated from field: gitpod.v1.BillingRealm realm = 2;
   */
  realm: BillingRealm;
};

/**
 * Describes the message gitpod.v1.SetBillingRealmRequest.
 * Use `create(SetBillingRealmRequestSchema)` to create a new message.
 */
export const SetBillingRealmRequestSchema: GenMessage<SetBillingRealmRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 34);

/**
 * @generated from message gitpod.v1.SetBillingRealmResponse
 */
export type SetBillingRealmResponse = Message<"gitpod.v1.SetBillingRealmResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetBillingRealmResponse.
 * Use `create(SetBillingRealmResponseSchema)` to create a new message.
 */
export const SetBillingRealmResponseSchema: GenMessage<SetBillingRealmResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 35);

/**
 * @generated from message gitpod.v1.CreateCardVerificationRequest
 */
export type CreateCardVerificationRequest = Message<"gitpod.v1.CreateCardVerificationRequest"> & {
  /**
   * email is the exact email address of the account
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * organization_id is the specific organization to verify (required if user has multiple orgs or already has a verified org)
   *
   * @generated from field: optional string organization_id = 2;
   */
  organizationId?: string;

  /**
   * reason is an optional description of why this email is being approved
   * (e.g., "Ona for Open Source - Project X")
   *
   * @generated from field: optional string reason = 3;
   */
  reason?: string;

  /**
   * free_credits is the number of free credits to grant when the user's Core
   * subscription is provisioned. If zero or unset, the default amount is used.
   *
   * @generated from field: optional int32 free_credits = 4;
   */
  freeCredits?: number;
};

/**
 * Describes the message gitpod.v1.CreateCardVerificationRequest.
 * Use `create(CreateCardVerificationRequestSchema)` to create a new message.
 */
export const CreateCardVerificationRequestSchema: GenMessage<CreateCardVerificationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 36);

/**
 * @generated from message gitpod.v1.CreateCardVerificationResponse
 */
export type CreateCardVerificationResponse = Message<"gitpod.v1.CreateCardVerificationResponse"> & {
};

/**
 * Describes the message gitpod.v1.CreateCardVerificationResponse.
 * Use `create(CreateCardVerificationResponseSchema)` to create a new message.
 */
export const CreateCardVerificationResponseSchema: GenMessage<CreateCardVerificationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 37);

/**
 * @generated from message gitpod.v1.SetTaxIDRequest
 */
export type SetTaxIDRequest = Message<"gitpod.v1.SetTaxIDRequest"> & {
  /**
   * organization_id is the ID of the organization to set tax ID for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * tax_id_type is the type of tax ID (e.g., "eu_vat", "us_ein", "gb_vat")
   *
   * @generated from field: string tax_id_type = 2;
   */
  taxIdType: string;

  /**
   * tax_id_value is the tax ID value
   *
   * @generated from field: string tax_id_value = 3;
   */
  taxIdValue: string;
};

/**
 * Describes the message gitpod.v1.SetTaxIDRequest.
 * Use `create(SetTaxIDRequestSchema)` to create a new message.
 */
export const SetTaxIDRequestSchema: GenMessage<SetTaxIDRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 38);

/**
 * @generated from message gitpod.v1.SetTaxIDResponse
 */
export type SetTaxIDResponse = Message<"gitpod.v1.SetTaxIDResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetTaxIDResponse.
 * Use `create(SetTaxIDResponseSchema)` to create a new message.
 */
export const SetTaxIDResponseSchema: GenMessage<SetTaxIDResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 39);

/**
 * Coupon represents a promotional code that can be redeemed for credits
 *
 * @generated from message gitpod.v1.Coupon
 */
export type Coupon = Message<"gitpod.v1.Coupon"> & {
  /**
   * id is the unique identifier for the coupon
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * code is the unique coupon code that customers can redeem
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * config is the configuration for this coupon
   *
   * @generated from field: gitpod.v1.CouponConfig config = 3;
   */
  config?: CouponConfig;

  /**
   * max_uses is the maximum number of times this coupon can be redeemed
   *
   * @generated from field: int32 max_uses = 4;
   */
  maxUses: number;

  /**
   * max_uses_per_org is the maximum number of times this coupon can be redeemed per organization
   *
   * @generated from field: optional int32 max_uses_per_org = 5;
   */
  maxUsesPerOrg?: number;

  /**
   * expires_at is when this coupon expires (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;

  /**
   * description is a human-readable description of the coupon
   *
   * @generated from field: optional string description = 7;
   */
  description?: string;

  /**
   * created_at is when the coupon was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * updated_at is when the coupon was last updated
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.Coupon.
 * Use `create(CouponSchema)` to create a new message.
 */
export const CouponSchema: GenMessage<Coupon> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 40);

/**
 * @generated from message gitpod.v1.CreateCouponRequest
 */
export type CreateCouponRequest = Message<"gitpod.v1.CreateCouponRequest"> & {
  /**
   * code is the unique coupon code that customers will redeem
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * config is the configuration for this coupon
   *
   * @generated from field: gitpod.v1.CouponConfig config = 2;
   */
  config?: CouponConfig;

  /**
   * max_uses is the maximum number of times this coupon can be redeemed
   *
   * @generated from field: int32 max_uses = 3;
   */
  maxUses: number;

  /**
   * max_uses_per_org is the maximum number of times this coupon can be redeemed per organization
   *
   * @generated from field: optional int32 max_uses_per_org = 4;
   */
  maxUsesPerOrg?: number;

  /**
   * expires_at is when this coupon expires (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp expires_at = 5;
   */
  expiresAt?: Timestamp;

  /**
   * description is a human-readable description of the coupon
   *
   * @generated from field: optional string description = 6;
   */
  description?: string;
};

/**
 * Describes the message gitpod.v1.CreateCouponRequest.
 * Use `create(CreateCouponRequestSchema)` to create a new message.
 */
export const CreateCouponRequestSchema: GenMessage<CreateCouponRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 41);

/**
 * @generated from message gitpod.v1.CouponConfig
 */
export type CouponConfig = Message<"gitpod.v1.CouponConfig"> & {
  /**
   * one_time_ocu_grant is the amount of OCU this coupon grants
   *
   * @generated from field: optional int64 one_time_ocu_grant = 1;
   */
  oneTimeOcuGrant?: bigint;

  /**
   * percentage_off is the percentage off this coupon grants
   *
   * @generated from field: optional int64 percentage_off = 2;
   */
  percentageOff?: bigint;

  /**
   * duration_months is the duration of the coupon in months
   *
   * @generated from field: optional int64 duration_months = 3;
   */
  durationMonths?: bigint;

  /**
   * auto_terminate is whether the subscription should be terminated after the duration has passed
   *
   * @generated from field: bool auto_terminate = 4;
   */
  autoTerminate: boolean;
};

/**
 * Describes the message gitpod.v1.CouponConfig.
 * Use `create(CouponConfigSchema)` to create a new message.
 */
export const CouponConfigSchema: GenMessage<CouponConfig> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 42);

/**
 * @generated from message gitpod.v1.CreateCouponResponse
 */
export type CreateCouponResponse = Message<"gitpod.v1.CreateCouponResponse"> & {
  /**
   * @generated from field: gitpod.v1.Coupon coupon = 1;
   */
  coupon?: Coupon;
};

/**
 * Describes the message gitpod.v1.CreateCouponResponse.
 * Use `create(CreateCouponResponseSchema)` to create a new message.
 */
export const CreateCouponResponseSchema: GenMessage<CreateCouponResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 43);

/**
 * @generated from message gitpod.v1.ListCouponsRequest
 */
export type ListCouponsRequest = Message<"gitpod.v1.ListCouponsRequest"> & {
  /**
   * pagination contains the pagination options for listing coupons
   *
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListCouponsRequest.Filter filter = 2;
   */
  filter?: ListCouponsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListCouponsRequest.
 * Use `create(ListCouponsRequestSchema)` to create a new message.
 */
export const ListCouponsRequestSchema: GenMessage<ListCouponsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 44);

/**
 * @generated from message gitpod.v1.ListCouponsRequest.Filter
 */
export type ListCouponsRequest_Filter = Message<"gitpod.v1.ListCouponsRequest.Filter"> & {
  /**
   * coupon_ids filters the response to only coupons with these IDs
   *
   * @generated from field: repeated string coupon_ids = 1;
   */
  couponIds: string[];

  /**
   * code filters coupons by exact code match
   *
   * @generated from field: optional string code = 4;
   */
  code?: string;

  /**
   * expires_before filters coupons that expire before this timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp expires_before = 5;
   */
  expiresBefore?: Timestamp;

  /**
   * expires_after filters coupons that expire after this timestamp
   *
   * @generated from field: optional google.protobuf.Timestamp expires_after = 6;
   */
  expiresAfter?: Timestamp;
};

/**
 * Describes the message gitpod.v1.ListCouponsRequest.Filter.
 * Use `create(ListCouponsRequest_FilterSchema)` to create a new message.
 */
export const ListCouponsRequest_FilterSchema: GenMessage<ListCouponsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 44, 0);

/**
 * @generated from message gitpod.v1.ListCouponsResponse
 */
export type ListCouponsResponse = Message<"gitpod.v1.ListCouponsResponse"> & {
  /**
   * pagination contains the pagination response
   *
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Coupon coupons = 2;
   */
  coupons: Coupon[];
};

/**
 * Describes the message gitpod.v1.ListCouponsResponse.
 * Use `create(ListCouponsResponseSchema)` to create a new message.
 */
export const ListCouponsResponseSchema: GenMessage<ListCouponsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 45);

/**
 * @generated from message gitpod.v1.GetCouponRequest
 */
export type GetCouponRequest = Message<"gitpod.v1.GetCouponRequest"> & {
  /**
   * coupon_code is the code of the coupon to retrieve
   *
   * @generated from field: string coupon_code = 1;
   */
  couponCode: string;

  /**
   * organization_id is the organization context for per-organization validation
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetCouponRequest.
 * Use `create(GetCouponRequestSchema)` to create a new message.
 */
export const GetCouponRequestSchema: GenMessage<GetCouponRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 46);

/**
 * @generated from message gitpod.v1.GetCouponResponse
 */
export type GetCouponResponse = Message<"gitpod.v1.GetCouponResponse"> & {
  /**
   * @generated from field: gitpod.v1.Coupon coupon = 1;
   */
  coupon?: Coupon;
};

/**
 * Describes the message gitpod.v1.GetCouponResponse.
 * Use `create(GetCouponResponseSchema)` to create a new message.
 */
export const GetCouponResponseSchema: GenMessage<GetCouponResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 47);

/**
 * BillingAddress represents a billing address for an organization
 *
 * @generated from message gitpod.v1.BillingAddress
 */
export type BillingAddress = Message<"gitpod.v1.BillingAddress"> & {
  /**
   * line1 is the first line of the address (street address)
   *
   * @generated from field: string line1 = 1;
   */
  line1: string;

  /**
   * line2 is the second line of the address (apartment, suite, etc.)
   *
   * @generated from field: string line2 = 2;
   */
  line2: string;

  /**
   * city is the city name
   *
   * @generated from field: string city = 3;
   */
  city: string;

  /**
   * state is the state or province
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * postal_code is the postal or ZIP code
   *
   * @generated from field: string postal_code = 5;
   */
  postalCode: string;

  /**
   * country is the two-letter country code (ISO 3166-1 alpha-2)
   *
   * @generated from field: string country = 6;
   */
  country: string;
};

/**
 * Describes the message gitpod.v1.BillingAddress.
 * Use `create(BillingAddressSchema)` to create a new message.
 */
export const BillingAddressSchema: GenMessage<BillingAddress> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 48);

/**
 * @generated from message gitpod.v1.SetBillingAddressRequest
 */
export type SetBillingAddressRequest = Message<"gitpod.v1.SetBillingAddressRequest"> & {
  /**
   * organization_id is the ID of the organization to set billing address for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * name is the name associated with the billing address
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * address is the billing address details
   *
   * @generated from field: gitpod.v1.BillingAddress address = 3;
   */
  address?: BillingAddress;
};

/**
 * Describes the message gitpod.v1.SetBillingAddressRequest.
 * Use `create(SetBillingAddressRequestSchema)` to create a new message.
 */
export const SetBillingAddressRequestSchema: GenMessage<SetBillingAddressRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 49);

/**
 * @generated from message gitpod.v1.SetBillingAddressResponse
 */
export type SetBillingAddressResponse = Message<"gitpod.v1.SetBillingAddressResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetBillingAddressResponse.
 * Use `create(SetBillingAddressResponseSchema)` to create a new message.
 */
export const SetBillingAddressResponseSchema: GenMessage<SetBillingAddressResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 50);

/**
 * @generated from message gitpod.v1.GetStripePortalUrlRequest
 */
export type GetStripePortalUrlRequest = Message<"gitpod.v1.GetStripePortalUrlRequest"> & {
  /**
   * organization_id is the ID of the organization to get the Stripe portal URL for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetStripePortalUrlRequest.
 * Use `create(GetStripePortalUrlRequestSchema)` to create a new message.
 */
export const GetStripePortalUrlRequestSchema: GenMessage<GetStripePortalUrlRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 51);

/**
 * @generated from message gitpod.v1.GetStripePortalUrlResponse
 */
export type GetStripePortalUrlResponse = Message<"gitpod.v1.GetStripePortalUrlResponse"> & {
  /**
   * portal_url is the URL to the Stripe Customer Portal for billing management
   *
   * @generated from field: string portal_url = 1;
   */
  portalUrl: string;
};

/**
 * Describes the message gitpod.v1.GetStripePortalUrlResponse.
 * Use `create(GetStripePortalUrlResponseSchema)` to create a new message.
 */
export const GetStripePortalUrlResponseSchema: GenMessage<GetStripePortalUrlResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 52);

/**
 * @generated from message gitpod.v1.ClearTopupFailureRequest
 */
export type ClearTopupFailureRequest = Message<"gitpod.v1.ClearTopupFailureRequest"> & {
  /**
   * organization_id is the ID of the organization to clear the topup failure for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.ClearTopupFailureRequest.
 * Use `create(ClearTopupFailureRequestSchema)` to create a new message.
 */
export const ClearTopupFailureRequestSchema: GenMessage<ClearTopupFailureRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 53);

/**
 * @generated from message gitpod.v1.ClearTopupFailureResponse
 */
export type ClearTopupFailureResponse = Message<"gitpod.v1.ClearTopupFailureResponse"> & {
};

/**
 * Describes the message gitpod.v1.ClearTopupFailureResponse.
 * Use `create(ClearTopupFailureResponseSchema)` to create a new message.
 */
export const ClearTopupFailureResponseSchema: GenMessage<ClearTopupFailureResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 54);

/**
 * @generated from message gitpod.v1.GetCreditConsumptionTimeSeriesRequest
 */
export type GetCreditConsumptionTimeSeriesRequest = Message<"gitpod.v1.GetCreditConsumptionTimeSeriesRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Date range for the consumption query. Optional; defaults to the last 7 days.
   * The range must not exceed 30 days, and end_time must not be in the future.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 3;
   */
  dateRange?: DateRange;
};

/**
 * Describes the message gitpod.v1.GetCreditConsumptionTimeSeriesRequest.
 * Use `create(GetCreditConsumptionTimeSeriesRequestSchema)` to create a new message.
 */
export const GetCreditConsumptionTimeSeriesRequestSchema: GenMessage<GetCreditConsumptionTimeSeriesRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 55);

/**
 * @generated from message gitpod.v1.GetCreditConsumptionTimeSeriesResponse
 */
export type GetCreditConsumptionTimeSeriesResponse = Message<"gitpod.v1.GetCreditConsumptionTimeSeriesResponse"> & {
  /**
   * Per-metric OCU consumption time series, plus a total entry with kind ALL.
   *
   * @generated from field: repeated gitpod.v1.MetricConsumptionTimeSeries metrics = 1;
   */
  metrics: MetricConsumptionTimeSeries[];
};

/**
 * Describes the message gitpod.v1.GetCreditConsumptionTimeSeriesResponse.
 * Use `create(GetCreditConsumptionTimeSeriesResponseSchema)` to create a new message.
 */
export const GetCreditConsumptionTimeSeriesResponseSchema: GenMessage<GetCreditConsumptionTimeSeriesResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 56);

/**
 * Daily OCU consumption for a single metric category.
 *
 * @generated from message gitpod.v1.MetricConsumptionTimeSeries
 */
export type MetricConsumptionTimeSeries = Message<"gitpod.v1.MetricConsumptionTimeSeries"> & {
  /**
   * Human-readable label (e.g. "Environment Usage", "LLM Cache Reads", "Total").
   *
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * Category for grouping and filtering.
   *
   * @generated from field: gitpod.v1.MetricConsumptionTimeSeries.Kind kind = 2;
   */
  kind: MetricConsumptionTimeSeries_Kind;

  /**
   * Daily data points.
   *
   * @generated from field: repeated gitpod.v1.CreditUsageDataPoint series = 3;
   */
  series: CreditUsageDataPoint[];
};

/**
 * Describes the message gitpod.v1.MetricConsumptionTimeSeries.
 * Use `create(MetricConsumptionTimeSeriesSchema)` to create a new message.
 */
export const MetricConsumptionTimeSeriesSchema: GenMessage<MetricConsumptionTimeSeries> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 57);

/**
 * @generated from enum gitpod.v1.MetricConsumptionTimeSeries.Kind
 */
export enum MetricConsumptionTimeSeries_Kind {
  /**
   * @generated from enum value: KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KIND_ALL = 1;
   */
  ALL = 1,

  /**
   * @generated from enum value: KIND_ENVIRONMENT = 2;
   */
  ENVIRONMENT = 2,

  /**
   * @generated from enum value: KIND_LLM = 3;
   */
  LLM = 3,
}

/**
 * Describes the enum gitpod.v1.MetricConsumptionTimeSeries.Kind.
 */
export const MetricConsumptionTimeSeries_KindSchema: GenEnum<MetricConsumptionTimeSeries_Kind> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 57, 0);

/**
 * A single data point in a credit consumption time series.
 *
 * @generated from message gitpod.v1.CreditUsageDataPoint
 */
export type CreditUsageDataPoint = Message<"gitpod.v1.CreditUsageDataPoint"> & {
  /**
   * Start of the day (UTC midnight).
   *
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * Cost in Ona Compute Units.
   *
   * @generated from field: double ocu = 2;
   */
  ocu: number;
};

/**
 * Describes the message gitpod.v1.CreditUsageDataPoint.
 * Use `create(CreditUsageDataPointSchema)` to create a new message.
 */
export const CreditUsageDataPointSchema: GenMessage<CreditUsageDataPoint> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 58);

/**
 * @generated from message gitpod.v1.SetupEnterpriseBillingRequest
 */
export type SetupEnterpriseBillingRequest = Message<"gitpod.v1.SetupEnterpriseBillingRequest"> & {
  /**
   * organization_id is the ID of the organization to set up enterprise billing for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * sandbox selects the sandbox billing environment. If false or unset, production is used.
   *
   * @generated from field: bool sandbox = 2;
   */
  sandbox: boolean;

  /**
   * set_enterprise_tier also sets the organization tier to Enterprise.
   * If false or unset, the organization must already be on Enterprise tier.
   *
   * @generated from field: bool set_enterprise_tier = 3;
   */
  setEnterpriseTier: boolean;

  /**
   * email is the email address for the Stripe customer (optional)
   *
   * @generated from field: optional string email = 4;
   */
  email?: string;

  /**
   * contract_start_date is the date from which usage data should be shown/exported.
   * Usage events before this date are still recorded but excluded from reports and Stripe sync.
   *
   * @generated from field: optional google.protobuf.Timestamp contract_start_date = 5;
   */
  contractStartDate?: Timestamp;
};

/**
 * Describes the message gitpod.v1.SetupEnterpriseBillingRequest.
 * Use `create(SetupEnterpriseBillingRequestSchema)` to create a new message.
 */
export const SetupEnterpriseBillingRequestSchema: GenMessage<SetupEnterpriseBillingRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 59);

/**
 * @generated from message gitpod.v1.SetupEnterpriseBillingResponse
 */
export type SetupEnterpriseBillingResponse = Message<"gitpod.v1.SetupEnterpriseBillingResponse"> & {
  /**
   * stripe_customer_id is the created or existing Stripe customer ID
   *
   * @generated from field: string stripe_customer_id = 1;
   */
  stripeCustomerId: string;
};

/**
 * Describes the message gitpod.v1.SetupEnterpriseBillingResponse.
 * Use `create(SetupEnterpriseBillingResponseSchema)` to create a new message.
 */
export const SetupEnterpriseBillingResponseSchema: GenMessage<SetupEnterpriseBillingResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 60);

/**
 * AutoTopupSettings configures automatic credit top-ups for an organization.
 *
 * @generated from message gitpod.v1.AutoTopupSettings
 */
export type AutoTopupSettings = Message<"gitpod.v1.AutoTopupSettings"> & {
  /**
   * Whether auto-topup is enabled.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * OCU amount per top-up. Must be one of: 40, 100, 200, 400, 1000.
   *
   * @generated from field: double amount_credits = 2;
   */
  amountCredits: number;

  /**
   * Maximum number of automatic top-ups per day (safety cap, 0 means no cap).
   *
   * @generated from field: int32 max_daily_topups = 3;
   */
  maxDailyTopups: number;
};

/**
 * Describes the message gitpod.v1.AutoTopupSettings.
 * Use `create(AutoTopupSettingsSchema)` to create a new message.
 */
export const AutoTopupSettingsSchema: GenMessage<AutoTopupSettings> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 61);

/**
 * @generated from message gitpod.v1.UpdateAutoTopupSettingsRequest
 */
export type UpdateAutoTopupSettingsRequest = Message<"gitpod.v1.UpdateAutoTopupSettingsRequest"> & {
  /**
   * organization_id is the ID of the organization to update auto-topup settings for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * settings contains the new auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 2;
   */
  settings?: AutoTopupSettings;
};

/**
 * Describes the message gitpod.v1.UpdateAutoTopupSettingsRequest.
 * Use `create(UpdateAutoTopupSettingsRequestSchema)` to create a new message.
 */
export const UpdateAutoTopupSettingsRequestSchema: GenMessage<UpdateAutoTopupSettingsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 62);

/**
 * @generated from message gitpod.v1.UpdateAutoTopupSettingsResponse
 */
export type UpdateAutoTopupSettingsResponse = Message<"gitpod.v1.UpdateAutoTopupSettingsResponse"> & {
  /**
   * settings contains the updated auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 1;
   */
  settings?: AutoTopupSettings;
};

/**
 * Describes the message gitpod.v1.UpdateAutoTopupSettingsResponse.
 * Use `create(UpdateAutoTopupSettingsResponseSchema)` to create a new message.
 */
export const UpdateAutoTopupSettingsResponseSchema: GenMessage<UpdateAutoTopupSettingsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 63);

/**
 * @generated from message gitpod.v1.GetAutoTopupSettingsRequest
 */
export type GetAutoTopupSettingsRequest = Message<"gitpod.v1.GetAutoTopupSettingsRequest"> & {
  /**
   * organization_id is the ID of the organization to get auto-topup settings for
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetAutoTopupSettingsRequest.
 * Use `create(GetAutoTopupSettingsRequestSchema)` to create a new message.
 */
export const GetAutoTopupSettingsRequestSchema: GenMessage<GetAutoTopupSettingsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 64);

/**
 * @generated from message gitpod.v1.GetAutoTopupSettingsResponse
 */
export type GetAutoTopupSettingsResponse = Message<"gitpod.v1.GetAutoTopupSettingsResponse"> & {
  /**
   * settings contains the current auto-topup configuration
   *
   * @generated from field: gitpod.v1.AutoTopupSettings settings = 1;
   */
  settings?: AutoTopupSettings;
};

/**
 * Describes the message gitpod.v1.GetAutoTopupSettingsResponse.
 * Use `create(GetAutoTopupSettingsResponseSchema)` to create a new message.
 */
export const GetAutoTopupSettingsResponseSchema: GenMessage<GetAutoTopupSettingsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 65);

/**
 * @generated from message gitpod.v1.GetCreditUsageReportRequest
 */
export type GetCreditUsageReportRequest = Message<"gitpod.v1.GetCreditUsageReportRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Date range for the report. Both start and end dates are inclusive.
   * Time-of-day is ignored; dates are truncated to midnight in the specified timezone.
   * The range must not exceed 31 days.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * IANA timezone name (e.g. "America/New_York", "Europe/Berlin") used to
   * bucket daily usage. When empty, defaults to "UTC".
   *
   * @generated from field: string timezone = 3;
   */
  timezone: string;
};

/**
 * Describes the message gitpod.v1.GetCreditUsageReportRequest.
 * Use `create(GetCreditUsageReportRequestSchema)` to create a new message.
 */
export const GetCreditUsageReportRequestSchema: GenMessage<GetCreditUsageReportRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 66);

/**
 * @generated from message gitpod.v1.GetCreditUsageReportResponse
 */
export type GetCreditUsageReportResponse = Message<"gitpod.v1.GetCreditUsageReportResponse"> & {
  /**
   * When the report data was last computed.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;

  /**
   * One entry per day in the requested date range.
   *
   * @generated from field: repeated gitpod.v1.DailyCreditUsage daily_usage = 2;
   */
  dailyUsage: DailyCreditUsage[];

  /**
   * Start of the billing period for this organization.
   * Used by the frontend to filter out months before usage tracking began.
   *
   * @generated from field: optional google.protobuf.Timestamp period_start = 3;
   */
  periodStart?: Timestamp;
};

/**
 * Describes the message gitpod.v1.GetCreditUsageReportResponse.
 * Use `create(GetCreditUsageReportResponseSchema)` to create a new message.
 */
export const GetCreditUsageReportResponseSchema: GenMessage<GetCreditUsageReportResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 67);

/**
 * DailyCreditUsage contains credit usage for a single day.
 *
 * @generated from message gitpod.v1.DailyCreditUsage
 */
export type DailyCreditUsage = Message<"gitpod.v1.DailyCreditUsage"> & {
  /**
   * Start of the day (midnight in the requested timezone).
   *
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;

  /**
   * Org-wide usage broken down by type.
   *
   * @generated from field: repeated gitpod.v1.CreditsByType org_usage = 2;
   */
  orgUsage: CreditsByType[];

  /**
   * Per-user usage for this day (top users + "Others").
   *
   * @generated from field: repeated gitpod.v1.UserCreditUsage user_usage = 3;
   */
  userUsage: UserCreditUsage[];

  /**
   * Per-team usage for this day (top teams + "Others").
   * Empty team_id represents the "Others" aggregation bucket.
   *
   * @generated from field: repeated gitpod.v1.TeamCreditUsage team_usage = 4;
   */
  teamUsage: TeamCreditUsage[];

  /**
   * Per-environment usage for this day (top environments + "Others").
   * Empty environment_id represents the "Others" aggregation bucket.
   *
   * @generated from field: repeated gitpod.v1.EnvironmentCreditUsage environment_usage = 5;
   */
  environmentUsage: EnvironmentCreditUsage[];

  /**
   * Per-agent-execution usage for this day (top conversations + "Others").
   * Empty agent_execution_id represents the "Others" aggregation bucket.
   *
   * @generated from field: repeated gitpod.v1.AgentExecutionCreditUsage conversation_usage = 6;
   */
  conversationUsage: AgentExecutionCreditUsage[];
};

/**
 * Describes the message gitpod.v1.DailyCreditUsage.
 * Use `create(DailyCreditUsageSchema)` to create a new message.
 */
export const DailyCreditUsageSchema: GenMessage<DailyCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 68);

/**
 * CreditsByType contains credits consumed for a single usage type.
 *
 * @generated from message gitpod.v1.CreditsByType
 */
export type CreditsByType = Message<"gitpod.v1.CreditsByType"> & {
  /**
   * @generated from field: gitpod.v1.UsageType usage_type = 1;
   */
  usageType: UsageType;

  /**
   * @generated from field: double credits = 2;
   */
  credits: number;
};

/**
 * Describes the message gitpod.v1.CreditsByType.
 * Use `create(CreditsByTypeSchema)` to create a new message.
 */
export const CreditsByTypeSchema: GenMessage<CreditsByType> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 69);

/**
 * UserCreditUsage contains a single user's credit usage, broken down by type.
 *
 * @generated from message gitpod.v1.UserCreditUsage
 */
export type UserCreditUsage = Message<"gitpod.v1.UserCreditUsage"> & {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[];
};

/**
 * Describes the message gitpod.v1.UserCreditUsage.
 * Use `create(UserCreditUsageSchema)` to create a new message.
 */
export const UserCreditUsageSchema: GenMessage<UserCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 70);

/**
 * TeamCreditUsage contains a single team's credit usage for a day, broken down by type.
 *
 * @generated from message gitpod.v1.TeamCreditUsage
 */
export type TeamCreditUsage = Message<"gitpod.v1.TeamCreditUsage"> & {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[];
};

/**
 * Describes the message gitpod.v1.TeamCreditUsage.
 * Use `create(TeamCreditUsageSchema)` to create a new message.
 */
export const TeamCreditUsageSchema: GenMessage<TeamCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 71);

/**
 * EnvironmentCreditUsage contains a single environment's credit usage for a day, broken down by type.
 *
 * @generated from message gitpod.v1.EnvironmentCreditUsage
 */
export type EnvironmentCreditUsage = Message<"gitpod.v1.EnvironmentCreditUsage"> & {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[];
};

/**
 * Describes the message gitpod.v1.EnvironmentCreditUsage.
 * Use `create(EnvironmentCreditUsageSchema)` to create a new message.
 */
export const EnvironmentCreditUsageSchema: GenMessage<EnvironmentCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 72);

/**
 * AgentExecutionCreditUsage contains a single agent execution's credit usage for a day, broken down by type.
 *
 * @generated from message gitpod.v1.AgentExecutionCreditUsage
 */
export type AgentExecutionCreditUsage = Message<"gitpod.v1.AgentExecutionCreditUsage"> & {
  /**
   * Empty when representing the "Others" aggregation bucket.
   *
   * @generated from field: string agent_execution_id = 1;
   */
  agentExecutionId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: repeated gitpod.v1.CreditsByType usage = 3;
   */
  usage: CreditsByType[];
};

/**
 * Describes the message gitpod.v1.AgentExecutionCreditUsage.
 * Use `create(AgentExecutionCreditUsageSchema)` to create a new message.
 */
export const AgentExecutionCreditUsageSchema: GenMessage<AgentExecutionCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 73);

/**
 * @generated from message gitpod.v1.GetCreditUsageExportRequest
 */
export type GetCreditUsageExportRequest = Message<"gitpod.v1.GetCreditUsageExportRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Month to export. Same semantics as GetCreditUsageReport.date_range.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * How to group the export data. Defaults to DAILY_SUMMARY.
   *
   * @generated from field: gitpod.v1.CreditUsageExportGroupBy group_by = 3;
   */
  groupBy: CreditUsageExportGroupBy;
};

/**
 * Describes the message gitpod.v1.GetCreditUsageExportRequest.
 * Use `create(GetCreditUsageExportRequestSchema)` to create a new message.
 */
export const GetCreditUsageExportRequestSchema: GenMessage<GetCreditUsageExportRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 74);

/**
 * @generated from message gitpod.v1.GetCreditUsageExportResponse
 */
export type GetCreditUsageExportResponse = Message<"gitpod.v1.GetCreditUsageExportResponse"> & {
  /**
   * Signed download URL for the CSV export. Short-lived (5 minutes).
   *
   * @generated from field: string download_url = 1;
   */
  downloadUrl: string;
};

/**
 * Describes the message gitpod.v1.GetCreditUsageExportResponse.
 * Use `create(GetCreditUsageExportResponseSchema)` to create a new message.
 */
export const GetCreditUsageExportResponseSchema: GenMessage<GetCreditUsageExportResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 75);

/**
 * @generated from message gitpod.v1.CorrectUsageEventsRequest
 */
export type CorrectUsageEventsRequest = Message<"gitpod.v1.CorrectUsageEventsRequest"> & {
  /**
   * Idempotency keys of events to correct.
   *
   * @generated from field: repeated string idempotency_keys = 1;
   */
  idempotencyKeys: string[];

  /**
   * Why these events are being corrected (stored in cancel_reason and correction payload).
   *
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message gitpod.v1.CorrectUsageEventsRequest.
 * Use `create(CorrectUsageEventsRequestSchema)` to create a new message.
 */
export const CorrectUsageEventsRequestSchema: GenMessage<CorrectUsageEventsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 76);

/**
 * @generated from message gitpod.v1.CorrectUsageEventsResponse
 */
export type CorrectUsageEventsResponse = Message<"gitpod.v1.CorrectUsageEventsResponse"> & {
  /**
   * @generated from field: repeated gitpod.v1.UsageEventCorrectionResult results = 1;
   */
  results: UsageEventCorrectionResult[];
};

/**
 * Describes the message gitpod.v1.CorrectUsageEventsResponse.
 * Use `create(CorrectUsageEventsResponseSchema)` to create a new message.
 */
export const CorrectUsageEventsResponseSchema: GenMessage<CorrectUsageEventsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 77);

/**
 * @generated from message gitpod.v1.UsageEventCorrectionResult
 */
export type UsageEventCorrectionResult = Message<"gitpod.v1.UsageEventCorrectionResult"> & {
  /**
   * @generated from field: string idempotency_key = 1;
   */
  idempotencyKey: string;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;

  /**
   * Error message if correction failed (e.g., event not found, already cancelled).
   *
   * @generated from field: string error = 3;
   */
  error: string;
};

/**
 * Describes the message gitpod.v1.UsageEventCorrectionResult.
 * Use `create(UsageEventCorrectionResultSchema)` to create a new message.
 */
export const UsageEventCorrectionResultSchema: GenMessage<UsageEventCorrectionResult> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 78);

/**
 * @generated from message gitpod.v1.InsertUsageEventsRequest
 */
export type InsertUsageEventsRequest = Message<"gitpod.v1.InsertUsageEventsRequest"> & {
  /**
   * Events to insert.
   *
   * @generated from field: repeated gitpod.v1.UsageEventInput events = 1;
   */
  events: UsageEventInput[];

  /**
   * Why these events are being inserted (stored in audit log and event payload).
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * If true, allow events with timestamps older than 35 days.
   * By default, old events are rejected because Stripe cannot accept them.
   *
   * @generated from field: bool ignore_age_check = 3;
   */
  ignoreAgeCheck: boolean;
};

/**
 * Describes the message gitpod.v1.InsertUsageEventsRequest.
 * Use `create(InsertUsageEventsRequestSchema)` to create a new message.
 */
export const InsertUsageEventsRequestSchema: GenMessage<InsertUsageEventsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 79);

/**
 * @generated from message gitpod.v1.UsageEventInput
 */
export type UsageEventInput = Message<"gitpod.v1.UsageEventInput"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Must be a known event type: "environment_usage" or "llm_usage".
   *
   * @generated from field: string event_name = 2;
   */
  eventName: string;

  /**
   * Unix epoch seconds. Raw int64 (not google.protobuf.Timestamp) to match
   * the storage model and allow direct CSV round-tripping.
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;

  /**
   * @generated from field: int64 value = 4;
   */
  value: bigint;

  /**
   * @generated from field: optional string user_id = 5;
   */
  userId?: string;

  /**
   * JSON-encoded payload metadata. Validated per event_name by the service.
   *
   * @generated from field: string payload_json = 6;
   */
  payloadJson: string;
};

/**
 * Describes the message gitpod.v1.UsageEventInput.
 * Use `create(UsageEventInputSchema)` to create a new message.
 */
export const UsageEventInputSchema: GenMessage<UsageEventInput> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 80);

/**
 * @generated from message gitpod.v1.InsertUsageEventsResponse
 */
export type InsertUsageEventsResponse = Message<"gitpod.v1.InsertUsageEventsResponse"> & {
  /**
   * One result per input event, in the same order as the request.
   * Each result echoes the original input fields plus status columns,
   * so the CLI can write the response directly to stdout as CSV.
   *
   * @generated from field: repeated gitpod.v1.UsageEventInsertResult results = 1;
   */
  results: UsageEventInsertResult[];

  /**
   * Summary counts.
   *
   * @generated from field: int32 inserted_count = 2;
   */
  insertedCount: number;

  /**
   * @generated from field: int32 skipped_count = 3;
   */
  skippedCount: number;

  /**
   * @generated from field: int32 error_count = 4;
   */
  errorCount: number;
};

/**
 * Describes the message gitpod.v1.InsertUsageEventsResponse.
 * Use `create(InsertUsageEventsResponseSchema)` to create a new message.
 */
export const InsertUsageEventsResponseSchema: GenMessage<InsertUsageEventsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 81);

/**
 * @generated from message gitpod.v1.UsageEventInsertResult
 */
export type UsageEventInsertResult = Message<"gitpod.v1.UsageEventInsertResult"> & {
  /**
   * Original input fields echoed back.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string event_name = 2;
   */
  eventName: string;

  /**
   * Unix epoch seconds (echoed from input).
   *
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;

  /**
   * @generated from field: int64 value = 4;
   */
  value: bigint;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: string payload_json = 6;
   */
  payloadJson: string;

  /**
   * "ok", "skipped", or "error".
   *
   * @generated from field: string status = 7;
   */
  status: string;

  /**
   * Generated idempotency key (empty for validation errors before key generation).
   *
   * @generated from field: string idempotency_key = 8;
   */
  idempotencyKey: string;

  /**
   * Error/skip reason (empty for status "ok").
   *
   * @generated from field: string message = 9;
   */
  message: string;
};

/**
 * Describes the message gitpod.v1.UsageEventInsertResult.
 * Use `create(UsageEventInsertResultSchema)` to create a new message.
 */
export const UsageEventInsertResultSchema: GenMessage<UsageEventInsertResult> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 82);

/**
 * @generated from message gitpod.v1.GetEnterpriseBillingInfoRequest
 */
export type GetEnterpriseBillingInfoRequest = Message<"gitpod.v1.GetEnterpriseBillingInfoRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetEnterpriseBillingInfoRequest.
 * Use `create(GetEnterpriseBillingInfoRequestSchema)` to create a new message.
 */
export const GetEnterpriseBillingInfoRequestSchema: GenMessage<GetEnterpriseBillingInfoRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 83);

/**
 * @generated from message gitpod.v1.GetEnterpriseBillingInfoResponse
 */
export type GetEnterpriseBillingInfoResponse = Message<"gitpod.v1.GetEnterpriseBillingInfoResponse"> & {
  /**
   * @generated from field: bool credit_usage_enabled = 1;
   */
  creditUsageEnabled: boolean;
};

/**
 * Describes the message gitpod.v1.GetEnterpriseBillingInfoResponse.
 * Use `create(GetEnterpriseBillingInfoResponseSchema)` to create a new message.
 */
export const GetEnterpriseBillingInfoResponseSchema: GenMessage<GetEnterpriseBillingInfoResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 84);

/**
 * @generated from message gitpod.v1.RequestRecoveryCreditRequest
 */
export type RequestRecoveryCreditRequest = Message<"gitpod.v1.RequestRecoveryCreditRequest"> & {
  /**
   * organization_id is the ID of the organization requesting recovery credits
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.RequestRecoveryCreditRequest.
 * Use `create(RequestRecoveryCreditRequestSchema)` to create a new message.
 */
export const RequestRecoveryCreditRequestSchema: GenMessage<RequestRecoveryCreditRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 85);

/**
 * @generated from message gitpod.v1.RequestRecoveryCreditResponse
 */
export type RequestRecoveryCreditResponse = Message<"gitpod.v1.RequestRecoveryCreditResponse"> & {
};

/**
 * Describes the message gitpod.v1.RequestRecoveryCreditResponse.
 * Use `create(RequestRecoveryCreditResponseSchema)` to create a new message.
 */
export const RequestRecoveryCreditResponseSchema: GenMessage<RequestRecoveryCreditResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 86);

/**
 * @generated from message gitpod.v1.GetCumulativeCreditUsageRequest
 */
export type GetCumulativeCreditUsageRequest = Message<"gitpod.v1.GetCumulativeCreditUsageRequest"> & {
  /**
   * organization_id is the ID of the organization to get cumulative usage for.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * as_of is the point in time to compute cumulative usage up to.
   * Defaults to now if not set.
   *
   * @generated from field: optional google.protobuf.Timestamp as_of = 2;
   */
  asOf?: Timestamp;
};

/**
 * Describes the message gitpod.v1.GetCumulativeCreditUsageRequest.
 * Use `create(GetCumulativeCreditUsageRequestSchema)` to create a new message.
 */
export const GetCumulativeCreditUsageRequestSchema: GenMessage<GetCumulativeCreditUsageRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 87);

/**
 * @generated from message gitpod.v1.GetCumulativeCreditUsageResponse
 */
export type GetCumulativeCreditUsageResponse = Message<"gitpod.v1.GetCumulativeCreditUsageResponse"> & {
  /**
   * Org-wide cumulative usage, broken down by type and total.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage org_usage = 1;
   */
  orgUsage?: CumulativeCreditUsage;

  /**
   * Per-team cumulative usage with credit allocation comparison.
   * Returns all teams (no top-N limit).
   *
   * @generated from field: repeated gitpod.v1.TeamCumulativeCreditUsage team_usage = 2;
   */
  teamUsage: TeamCumulativeCreditUsage[];

  /**
   * Usage by members not assigned to any team.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage unteamed_usage = 3;
   */
  unteamedUsage?: CumulativeCreditUsage;

  /**
   * Start of the cumulative calculation period.
   * Cumulative totals are computed from this date forward.
   *
   * @generated from field: google.protobuf.Timestamp period_start = 4;
   */
  periodStart?: Timestamp;
};

/**
 * Describes the message gitpod.v1.GetCumulativeCreditUsageResponse.
 * Use `create(GetCumulativeCreditUsageResponseSchema)` to create a new message.
 */
export const GetCumulativeCreditUsageResponseSchema: GenMessage<GetCumulativeCreditUsageResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 88);

/**
 * CumulativeCreditUsage contains cumulative credit consumption totals.
 *
 * @generated from message gitpod.v1.CumulativeCreditUsage
 */
export type CumulativeCreditUsage = Message<"gitpod.v1.CumulativeCreditUsage"> & {
  /**
   * Total credits consumed.
   *
   * @generated from field: double total_credits = 1;
   */
  totalCredits: number;

  /**
   * Credits consumed broken down by usage type.
   *
   * @generated from field: repeated gitpod.v1.CreditsByType usage_by_type = 2;
   */
  usageByType: CreditsByType[];
};

/**
 * Describes the message gitpod.v1.CumulativeCreditUsage.
 * Use `create(CumulativeCreditUsageSchema)` to create a new message.
 */
export const CumulativeCreditUsageSchema: GenMessage<CumulativeCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 89);

/**
 * TeamCumulativeCreditUsage contains a team's cumulative credit usage and allocation.
 *
 * @generated from message gitpod.v1.TeamCumulativeCreditUsage
 */
export type TeamCumulativeCreditUsage = Message<"gitpod.v1.TeamCumulativeCreditUsage"> & {
  /**
   * @generated from field: string team_id = 1;
   */
  teamId: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Cumulative credit usage for this team.
   *
   * @generated from field: gitpod.v1.CumulativeCreditUsage usage = 3;
   */
  usage?: CumulativeCreditUsage;

  /**
   * The team's credit allocation (budget) in whole credits, if set.
   * Not set means no allocation has been configured for this team.
   *
   * @generated from field: optional int64 credit_budget = 4;
   */
  creditBudget?: bigint;
};

/**
 * Describes the message gitpod.v1.TeamCumulativeCreditUsage.
 * Use `create(TeamCumulativeCreditUsageSchema)` to create a new message.
 */
export const TeamCumulativeCreditUsageSchema: GenMessage<TeamCumulativeCreditUsage> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 90);

/**
 * TeamCreditAllocationInfo represents a team's credit budget allocation.
 *
 * @generated from message gitpod.v1.TeamCreditAllocationInfo
 */
export type TeamCreditAllocationInfo = Message<"gitpod.v1.TeamCreditAllocationInfo"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string organization_id = 3;
   */
  organizationId: string;

  /**
   * credit_budget is the allocated credit budget in whole credits.
   *
   * @generated from field: int64 credit_budget = 4;
   */
  creditBudget: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.TeamCreditAllocationInfo.
 * Use `create(TeamCreditAllocationInfoSchema)` to create a new message.
 */
export const TeamCreditAllocationInfoSchema: GenMessage<TeamCreditAllocationInfo> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 91);

/**
 * @generated from message gitpod.v1.CreateTeamCreditAllocationRequest
 */
export type CreateTeamCreditAllocationRequest = Message<"gitpod.v1.CreateTeamCreditAllocationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * credit_budget is the allocated credit budget in whole credits. Must be > 0.
   *
   * @generated from field: int64 credit_budget = 3;
   */
  creditBudget: bigint;
};

/**
 * Describes the message gitpod.v1.CreateTeamCreditAllocationRequest.
 * Use `create(CreateTeamCreditAllocationRequestSchema)` to create a new message.
 */
export const CreateTeamCreditAllocationRequestSchema: GenMessage<CreateTeamCreditAllocationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 92);

/**
 * @generated from message gitpod.v1.CreateTeamCreditAllocationResponse
 */
export type CreateTeamCreditAllocationResponse = Message<"gitpod.v1.CreateTeamCreditAllocationResponse"> & {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;
};

/**
 * Describes the message gitpod.v1.CreateTeamCreditAllocationResponse.
 * Use `create(CreateTeamCreditAllocationResponseSchema)` to create a new message.
 */
export const CreateTeamCreditAllocationResponseSchema: GenMessage<CreateTeamCreditAllocationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 93);

/**
 * @generated from message gitpod.v1.GetTeamCreditAllocationRequest
 */
export type GetTeamCreditAllocationRequest = Message<"gitpod.v1.GetTeamCreditAllocationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.GetTeamCreditAllocationRequest.
 * Use `create(GetTeamCreditAllocationRequestSchema)` to create a new message.
 */
export const GetTeamCreditAllocationRequestSchema: GenMessage<GetTeamCreditAllocationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 94);

/**
 * @generated from message gitpod.v1.GetTeamCreditAllocationResponse
 */
export type GetTeamCreditAllocationResponse = Message<"gitpod.v1.GetTeamCreditAllocationResponse"> & {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;
};

/**
 * Describes the message gitpod.v1.GetTeamCreditAllocationResponse.
 * Use `create(GetTeamCreditAllocationResponseSchema)` to create a new message.
 */
export const GetTeamCreditAllocationResponseSchema: GenMessage<GetTeamCreditAllocationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 95);

/**
 * @generated from message gitpod.v1.UpdateTeamCreditAllocationRequest
 */
export type UpdateTeamCreditAllocationRequest = Message<"gitpod.v1.UpdateTeamCreditAllocationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * credit_budget is the new allocated credit budget in whole credits. Must be > 0.
   *
   * @generated from field: int64 credit_budget = 3;
   */
  creditBudget: bigint;
};

/**
 * Describes the message gitpod.v1.UpdateTeamCreditAllocationRequest.
 * Use `create(UpdateTeamCreditAllocationRequestSchema)` to create a new message.
 */
export const UpdateTeamCreditAllocationRequestSchema: GenMessage<UpdateTeamCreditAllocationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 96);

/**
 * @generated from message gitpod.v1.UpdateTeamCreditAllocationResponse
 */
export type UpdateTeamCreditAllocationResponse = Message<"gitpod.v1.UpdateTeamCreditAllocationResponse"> & {
  /**
   * @generated from field: gitpod.v1.TeamCreditAllocationInfo allocation = 1;
   */
  allocation?: TeamCreditAllocationInfo;
};

/**
 * Describes the message gitpod.v1.UpdateTeamCreditAllocationResponse.
 * Use `create(UpdateTeamCreditAllocationResponseSchema)` to create a new message.
 */
export const UpdateTeamCreditAllocationResponseSchema: GenMessage<UpdateTeamCreditAllocationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 97);

/**
 * @generated from message gitpod.v1.DeleteTeamCreditAllocationRequest
 */
export type DeleteTeamCreditAllocationRequest = Message<"gitpod.v1.DeleteTeamCreditAllocationRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * Describes the message gitpod.v1.DeleteTeamCreditAllocationRequest.
 * Use `create(DeleteTeamCreditAllocationRequestSchema)` to create a new message.
 */
export const DeleteTeamCreditAllocationRequestSchema: GenMessage<DeleteTeamCreditAllocationRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 98);

/**
 * @generated from message gitpod.v1.DeleteTeamCreditAllocationResponse
 */
export type DeleteTeamCreditAllocationResponse = Message<"gitpod.v1.DeleteTeamCreditAllocationResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteTeamCreditAllocationResponse.
 * Use `create(DeleteTeamCreditAllocationResponseSchema)` to create a new message.
 */
export const DeleteTeamCreditAllocationResponseSchema: GenMessage<DeleteTeamCreditAllocationResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 99);

/**
 * @generated from message gitpod.v1.SetOrganizationCreditGrantRequest
 */
export type SetOrganizationCreditGrantRequest = Message<"gitpod.v1.SetOrganizationCreditGrantRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * credit_grant is the contracted credit grant in whole credits. Must be >= 0.
   *
   * @generated from field: int64 credit_grant = 2;
   */
  creditGrant: bigint;
};

/**
 * Describes the message gitpod.v1.SetOrganizationCreditGrantRequest.
 * Use `create(SetOrganizationCreditGrantRequestSchema)` to create a new message.
 */
export const SetOrganizationCreditGrantRequestSchema: GenMessage<SetOrganizationCreditGrantRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 100);

/**
 * @generated from message gitpod.v1.SetOrganizationCreditGrantResponse
 */
export type SetOrganizationCreditGrantResponse = Message<"gitpod.v1.SetOrganizationCreditGrantResponse"> & {
};

/**
 * Describes the message gitpod.v1.SetOrganizationCreditGrantResponse.
 * Use `create(SetOrganizationCreditGrantResponseSchema)` to create a new message.
 */
export const SetOrganizationCreditGrantResponseSchema: GenMessage<SetOrganizationCreditGrantResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 101);

/**
 * Specifies a single environment and the time range of events to correct.
 *
 * @generated from message gitpod.v1.EnvironmentCorrectionSpec
 */
export type EnvironmentCorrectionSpec = Message<"gitpod.v1.EnvironmentCorrectionSpec"> & {
  /**
   * Environment ID to correct usage events for.
   *
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * Only correct events with timestamps at or after this time.
   *
   * @generated from field: google.protobuf.Timestamp start_time = 2;
   */
  startTime?: Timestamp;

  /**
   * Only correct events with timestamps at or before this time.
   *
   * @generated from field: google.protobuf.Timestamp end_time = 3;
   */
  endTime?: Timestamp;
};

/**
 * Describes the message gitpod.v1.EnvironmentCorrectionSpec.
 * Use `create(EnvironmentCorrectionSpecSchema)` to create a new message.
 */
export const EnvironmentCorrectionSpecSchema: GenMessage<EnvironmentCorrectionSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 102);

/**
 * @generated from message gitpod.v1.CorrectEnvironmentUsageEventsRequest
 */
export type CorrectEnvironmentUsageEventsRequest = Message<"gitpod.v1.CorrectEnvironmentUsageEventsRequest"> & {
  /**
   * Per-environment correction specs. Each entry identifies an environment
   * and the time window of usage events to correct.
   *
   * @generated from field: repeated gitpod.v1.EnvironmentCorrectionSpec corrections = 1;
   */
  corrections: EnvironmentCorrectionSpec[];

  /**
   * Why these events are being corrected.
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * If true, only report what would be corrected without making changes.
   *
   * @generated from field: bool dry_run = 5;
   */
  dryRun: boolean;
};

/**
 * Describes the message gitpod.v1.CorrectEnvironmentUsageEventsRequest.
 * Use `create(CorrectEnvironmentUsageEventsRequestSchema)` to create a new message.
 */
export const CorrectEnvironmentUsageEventsRequestSchema: GenMessage<CorrectEnvironmentUsageEventsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 103);

/**
 * @generated from message gitpod.v1.CorrectEnvironmentUsageEventsResponse
 */
export type CorrectEnvironmentUsageEventsResponse = Message<"gitpod.v1.CorrectEnvironmentUsageEventsResponse"> & {
  /**
   * Per-event correction results (empty in dry-run mode).
   *
   * @generated from field: repeated gitpod.v1.UsageEventCorrectionResult results = 1;
   */
  results: UsageEventCorrectionResult[];

  /**
   * Total number of correctable events found.
   *
   * @generated from field: int32 total_events = 2;
   */
  totalEvents: number;

  /**
   * Total value (seconds) across all correctable events.
   *
   * @generated from field: int64 total_value = 3;
   */
  totalValue: bigint;

  /**
   * Number of events with timestamps older than 35 days (beyond Stripe's limit).
   *
   * @generated from field: int32 beyond_stripe_limit_count = 4;
   */
  beyondStripeLimitCount: number;

  /**
   * Total value of events beyond the 35-day Stripe limit.
   *
   * @generated from field: int64 beyond_stripe_limit_value = 5;
   */
  beyondStripeLimitValue: bigint;

  /**
   * Per-environment summary.
   *
   * @generated from field: repeated gitpod.v1.EnvironmentUsageSummary environment_summaries = 6;
   */
  environmentSummaries: EnvironmentUsageSummary[];
};

/**
 * Describes the message gitpod.v1.CorrectEnvironmentUsageEventsResponse.
 * Use `create(CorrectEnvironmentUsageEventsResponseSchema)` to create a new message.
 */
export const CorrectEnvironmentUsageEventsResponseSchema: GenMessage<CorrectEnvironmentUsageEventsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 104);

/**
 * @generated from message gitpod.v1.EnvironmentUsageSummary
 */
export type EnvironmentUsageSummary = Message<"gitpod.v1.EnvironmentUsageSummary"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: int32 event_count = 2;
   */
  eventCount: number;

  /**
   * @generated from field: int64 total_value = 3;
   */
  totalValue: bigint;
};

/**
 * Describes the message gitpod.v1.EnvironmentUsageSummary.
 * Use `create(EnvironmentUsageSummarySchema)` to create a new message.
 */
export const EnvironmentUsageSummarySchema: GenMessage<EnvironmentUsageSummary> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_billing, 105);

/**
 * @generated from enum gitpod.v1.BillingPlanKind
 */
export enum BillingPlanKind {
  /**
   * @generated from enum value: BILLING_PLAN_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_PLAN_KIND_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: BILLING_PLAN_KIND_CORE = 2;
   */
  CORE = 2,
}

/**
 * Describes the enum gitpod.v1.BillingPlanKind.
 */
export const BillingPlanKindSchema: GenEnum<BillingPlanKind> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 0);

/**
 * @generated from enum gitpod.v1.CreditCardVerificationStatus
 */
export enum CreditCardVerificationStatus {
  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_REQUIRES_CONFIRMATION = 2;
   */
  REQUIRES_CONFIRMATION = 2,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INVALID_CVC = 3;
   */
  INVALID_CVC = 3,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INVALID_NUMBER = 4;
   */
  INVALID_NUMBER = 4,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_INSUFFICIENT_FUNDS = 5;
   */
  INSUFFICIENT_FUNDS = 5,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_EXPIRED_CARD = 6;
   */
  EXPIRED_CARD = 6,

  /**
   * catch all for all other errors
   *
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_FAILED = 7;
   */
  FAILED = 7,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_SUCCESS = 8;
   */
  SUCCESS = 8,

  /**
   * @generated from enum value: CREDIT_CARD_VERIFICATION_STATUS_NOT_REQUIRED = 9;
   */
  NOT_REQUIRED = 9,
}

/**
 * Describes the enum gitpod.v1.CreditCardVerificationStatus.
 */
export const CreditCardVerificationStatusSchema: GenEnum<CreditCardVerificationStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 1);

/**
 * @generated from enum gitpod.v1.PaymentFailureState
 */
export enum PaymentFailureState {
  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_IN_GRACE = 1;
   */
  IN_GRACE = 1,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_SUSPENDED = 2;
   */
  SUSPENDED = 2,

  /**
   * @generated from enum value: PAYMENT_FAILURE_STATE_RESOLVED = 3;
   */
  RESOLVED = 3,
}

/**
 * Describes the enum gitpod.v1.PaymentFailureState.
 */
export const PaymentFailureStateSchema: GenEnum<PaymentFailureState> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 2);

/**
 * @generated from enum gitpod.v1.CreditStatus
 */
export enum CreditStatus {
  /**
   * @generated from enum value: CREDIT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CREDIT_STATUS_OUT_OF_CREDITS = 1;
   */
  OUT_OF_CREDITS = 1,

  /**
   * @generated from enum value: CREDIT_STATUS_LOW_ON_CREDITS = 2;
   */
  LOW_ON_CREDITS = 2,

  /**
   * @generated from enum value: CREDIT_STATUS_HAS_CREDITS = 3;
   */
  HAS_CREDITS = 3,
}

/**
 * Describes the enum gitpod.v1.CreditStatus.
 */
export const CreditStatusSchema: GenEnum<CreditStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 3);

/**
 * @generated from enum gitpod.v1.PaymentMethodStatus
 */
export enum PaymentMethodStatus {
  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_NOT_SET_UP = 1;
   */
  NOT_SET_UP = 1,

  /**
   * @generated from enum value: PAYMENT_METHOD_STATUS_VERIFIED = 2;
   */
  VERIFIED = 2,
}

/**
 * Describes the enum gitpod.v1.PaymentMethodStatus.
 */
export const PaymentMethodStatusSchema: GenEnum<PaymentMethodStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 4);

/**
 * @generated from enum gitpod.v1.BillingRealm
 */
export enum BillingRealm {
  /**
   * @generated from enum value: BILLING_REALM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BILLING_REALM_SANDBOX = 1;
   */
  SANDBOX = 1,

  /**
   * @generated from enum value: BILLING_REALM_PRODUCTION = 2;
   */
  PRODUCTION = 2,
}

/**
 * Describes the enum gitpod.v1.BillingRealm.
 */
export const BillingRealmSchema: GenEnum<BillingRealm> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 5);

/**
 * @generated from enum gitpod.v1.SubscriptionType
 */
export enum SubscriptionType {
  /**
   * @generated from enum value: SUBSCRIPTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_TYPE_CORE = 1;
   */
  CORE = 1,
}

/**
 * Describes the enum gitpod.v1.SubscriptionType.
 */
export const SubscriptionTypeSchema: GenEnum<SubscriptionType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 6);

/**
 * @generated from enum gitpod.v1.SubscriptionStatus
 */
export enum SubscriptionStatus {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELLED = 2;
   */
  CANCELLED = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PENDING = 4;
   */
  PENDING = 4,
}

/**
 * Describes the enum gitpod.v1.SubscriptionStatus.
 */
export const SubscriptionStatusSchema: GenEnum<SubscriptionStatus> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 7);

/**
 * UsageType identifies the category of usage.
 *
 * @generated from enum gitpod.v1.UsageType
 */
export enum UsageType {
  /**
   * @generated from enum value: USAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: USAGE_TYPE_ENVIRONMENT = 1;
   */
  ENVIRONMENT = 1,

  /**
   * @generated from enum value: USAGE_TYPE_AGENTIC = 2;
   */
  AGENTIC = 2,
}

/**
 * Describes the enum gitpod.v1.UsageType.
 */
export const UsageTypeSchema: GenEnum<UsageType> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 8);

/**
 * How to group the credit usage export data.
 *
 * @generated from enum gitpod.v1.CreditUsageExportGroupBy
 */
export enum CreditUsageExportGroupBy {
  /**
   * Defaults to DAILY_SUMMARY.
   *
   * @generated from enum value: CREDIT_USAGE_EXPORT_GROUP_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Daily summary grouped by user.
   *
   * @generated from enum value: CREDIT_USAGE_EXPORT_GROUP_BY_DAILY_SUMMARY = 1;
   */
  DAILY_SUMMARY = 1,

  /**
   * Breakdown by environment and agent execution.
   *
   * @generated from enum value: CREDIT_USAGE_EXPORT_GROUP_BY_RESOURCE = 2;
   */
  RESOURCE = 2,
}

/**
 * Describes the enum gitpod.v1.CreditUsageExportGroupBy.
 */
export const CreditUsageExportGroupBySchema: GenEnum<CreditUsageExportGroupBy> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_billing, 9);

/**
 * BillingService provides billing and subscription management functionality.
 *
 * @generated from service gitpod.v1.BillingService
 */
export const BillingService: GenService<{
  /**
   * @generated from rpc gitpod.v1.BillingService.SetupBilling
   */
  setupBilling: {
    methodKind: "unary";
    input: typeof SetupBillingRequestSchema;
    output: typeof SetupBillingResponseSchema;
  },
  /**
   * Completes the billing setup process after Stripe payment workflow completion.
   *
   * Use this method to:
   * - Verify Stripe setup intent completion
   * - Create Metronome contract for the organization
   * - Grant free trial credits
   * - Finalize billing configuration
   *
   * ### Examples
   *
   * - Complete billing setup:
   *
   *   Finalizes billing after successful Stripe payment setup.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   setupIntentId: "seti_1234567890abcdef"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.CompleteBillingSetup
   */
  completeBillingSetup: {
    methodKind: "unary";
    input: typeof CompleteBillingSetupRequestSchema;
    output: typeof CompleteBillingSetupResponseSchema;
  },
  /**
   * Retrieves billing information including credit balance for an organization.
   *
   * Use this method to:
   * - Check available credits for the organization
   * - Monitor credit usage and remaining balance
   * - Display billing status in the dashboard
   * - Implement usage-based alerts
   *
   * ### Examples
   *
   * - Get billing info:
   *
   *   Retrieves current credit balance and usage information.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.GetBillingInfo
   */
  getBillingInfo: {
    methodKind: "unary";
    input: typeof GetBillingInfoRequestSchema;
    output: typeof GetBillingInfoResponseSchema;
  },
  /**
   * Reconciles billing state for an organization.
   *
   * Use this method to:
   * - Ensure billing state is up-to-date with external providers (Stripe, Metronome)
   * - Sync organization tier based on active contracts
   * - Update credit status and payment failure state
   *
   * Call this when the user navigates to the billing page to ensure
   * they see the most current billing information.
   *
   * ### Examples
   *
   * - Reconcile billing:
   *
   *   Triggers billing reconciliation for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.ReconcileBilling
   */
  reconcileBilling: {
    methodKind: "unary";
    input: typeof ReconcileBillingRequestSchema;
    output: typeof ReconcileBillingResponseSchema;
  },
  /**
   * Creates a new subscription for an organization.
   *
   * Use this method to:
   * - Create a new subscription with specified type
   * - Add subscription to existing Metronome contract
   * - Create new contract if none exists
   *
   * @generated from rpc gitpod.v1.BillingService.CreateSubscription
   */
  createSubscription: {
    methodKind: "unary";
    input: typeof CreateSubscriptionRequestSchema;
    output: typeof CreateSubscriptionResponseSchema;
  },
  /**
   * Cancels an existing subscription.
   *
   * Use this method to:
   * - Cancel active subscription
   * - Stop recurring billing
   * - Maintain access until end of billing period
   *
   * ### Examples
   *
   * - Cancel subscription:
   *
   *   Cancels the specified subscription.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   subscriptionType: SUBSCRIPTION_TYPE_CORE
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.CancelSubscription
   */
  cancelSubscription: {
    methodKind: "unary";
    input: typeof CancelSubscriptionRequestSchema;
    output: typeof CancelSubscriptionResponseSchema;
  },
  /**
   * Updates an existing subscription's amount mid billing period, without cancellation.
   *
   * Use this method to:
   * - Change the subscription amount without cancelling and re-subscribing
   * - Switch between billing plans mid billing cycle
   *
   * @generated from rpc gitpod.v1.BillingService.UpdateSubscription
   */
  updateSubscription: {
    methodKind: "unary";
    input: typeof UpdateSubscriptionRequestSchema;
    output: typeof UpdateSubscriptionResponseSchema;
  },
  /**
   * Lists current subscriptions for an organization.
   *
   * Use this method to:
   * - View all active subscriptions
   * - Check subscription status and details
   * - Monitor subscription lifecycle
   *
   * ### Examples
   *
   * - List subscriptions:
   *
   *   Retrieves all subscriptions for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.ListSubscriptions
   */
  listSubscriptions: {
    methodKind: "unary";
    input: typeof ListSubscriptionsRequestSchema;
    output: typeof ListSubscriptionsResponseSchema;
  },
  /**
   * Grants additional credits to an organization.
   *
   * Use this method to:
   * - Grant credits to existing customers
   * - Add promotional credits
   * - Provide customer service credits
   *
   * ### Examples
   *
   * - Grant credits:
   *
   *   Grants 80 credits to the organization for one year.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   creditsAmount: 80.0
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.GrantCredits
   */
  grantCredits: {
    methodKind: "unary";
    input: typeof GrantCreditsRequestSchema;
    output: typeof GrantCreditsResponseSchema;
  },
  /**
   * Retrieves the Stripe publishable key for an organization.
   *
   * Use this method to:
   * - Get the appropriate Stripe publishable key for frontend payment forms
   * - Support different billing realms (production/sandbox)
   * - Ensure proper isolation between organizations
   *
   * ### Examples
   *
   * - Get publishable key:
   *
   *   Retrieves the Stripe publishable key for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.GetStripePublishableKey
   */
  getStripePublishableKey: {
    methodKind: "unary";
    input: typeof GetStripePublishableKeyRequestSchema;
    output: typeof GetStripePublishableKeyResponseSchema;
  },
  /**
   * Sets the billing realm for an organization.
   *
   * Use this method to:
   * - Change organization's billing realm between sandbox and production
   * - Configure billing environment for the organization
   * - Requires Account permissions to perform the operation
   *
   * ### Examples
   *
   * - Set billing realm:
   *
   *   Changes organization billing realm to production.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   realm: BILLING_REALM_PRODUCTION
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.SetBillingRealm
   */
  setBillingRealm: {
    methodKind: "unary";
    input: typeof SetBillingRealmRequestSchema;
    output: typeof SetBillingRealmResponseSchema;
  },
  /**
   * Creates a card verification entry for an account, allowing them to skip credit card verification.
   *
   * Use this method to:
   * - Grant Ona for Open Source program participants immediate access
   * - Mark pre-vetted accounts as credit card verified
   *
   * Requires the 'create_card_verification' account permission.
   *
   * ### Examples
   *
   * - Create card verification for open source maintainer:
   *
   *   ```yaml
   *   email: "maintainer@example.org"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.CreateCardVerification
   */
  createCardVerification: {
    methodKind: "unary";
    input: typeof CreateCardVerificationRequestSchema;
    output: typeof CreateCardVerificationResponseSchema;
  },
  /**
   * Sets or updates the tax ID for an organization.
   *
   * Use this method to:
   * - Set tax ID for billing purposes
   * - Update existing tax ID information
   * - Support various tax ID types (VAT, GST, etc.)
   *
   * ### Examples
   *
   * - Set EU VAT ID:
   *
   *   Sets a VAT ID for an EU organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   taxIdType: "eu_vat"
   *   taxIdValue: "DE123456789"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.SetTaxID
   */
  setTaxID: {
    methodKind: "unary";
    input: typeof SetTaxIDRequestSchema;
    output: typeof SetTaxIDResponseSchema;
  },
  /**
   * Gets details about a specific billing record.
   *
   * @generated from rpc gitpod.v1.BillingService.GetBillingRecord
   */
  getBillingRecord: {
    methodKind: "unary";
    input: typeof GetBillingRecordRequestSchema;
    output: typeof GetBillingRecordResponseSchema;
  },
  /**
   * Updates a billing record
   *
   * @generated from rpc gitpod.v1.BillingService.UpdateBillingRecord
   */
  updateBillingRecord: {
    methodKind: "unary";
    input: typeof UpdateBillingRecordRequestSchema;
    output: typeof UpdateBillingRecordResponseSchema;
  },
  /**
   * Creates a new coupon for support staff to distribute to customers.
   *
   * Use this method to:
   * - Create promotional coupons for marketing campaigns
   * - Generate support coupons for customer service
   * - Set up trial credit coupons for new users
   *
   * @generated from rpc gitpod.v1.BillingService.CreateCoupon
   */
  createCoupon: {
    methodKind: "unary";
    input: typeof CreateCouponRequestSchema;
    output: typeof CreateCouponResponseSchema;
  },
  /**
   * Lists existing coupons with filtering and pagination support.
   *
   * Use this method to:
   * - View all created coupons
   * - Filter coupons by status or type
   * - Monitor coupon usage and expiration
   *
   * @generated from rpc gitpod.v1.BillingService.ListCoupons
   */
  listCoupons: {
    methodKind: "unary";
    input: typeof ListCouponsRequestSchema;
    output: typeof ListCouponsResponseSchema;
  },
  /**
   * Retrieves a specific coupon by its code.
   *
   * Use this method to:
   * - Validate coupon codes during checkout
   * - Display coupon details to users
   * - Check coupon availability and expiration
   *
   * ### Examples
   *
   * - Get coupon by code:
   *
   *   Retrieves coupon details for validation.
   *
   *   ```yaml
   *   couponCode: "WELCOME2024"
   *   organizationId: "123e4567-e89b-12d3-a456-426614174000"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.GetCoupon
   */
  getCoupon: {
    methodKind: "unary";
    input: typeof GetCouponRequestSchema;
    output: typeof GetCouponResponseSchema;
  },
  /**
   * Sets or updates the billing address for an organization.
   *
   * Use this method to:
   * - Set billing address for tax calculation and compliance
   * - Update existing billing address information
   * - Support international billing requirements
   *
   * ### Examples
   *
   * - Set billing address:
   *
   *   Sets a complete billing address for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   name: "John Doe"
   *   address:
   *     line1: "123 Main St"
   *     line2: "Suite 100"
   *     city: "San Francisco"
   *     state: "CA"
   *     postalCode: "94105"
   *     country: "US"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.SetBillingAddress
   */
  setBillingAddress: {
    methodKind: "unary";
    input: typeof SetBillingAddressRequestSchema;
    output: typeof SetBillingAddressResponseSchema;
  },
  /**
   * Retrieves the Stripe Customer Portal URL for an organization.
   *
   * Use this method to:
   * - Get the Stripe Customer Portal URL for billing management
   * - Allow customers to manage their payment methods and billing details
   * - Provide access to billing history and invoices
   *
   * ### Examples
   *
   * - Get Stripe portal URL:
   *
   *   Retrieves the portal URL for the organization.
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.GetStripePortalUrl
   */
  getStripePortalUrl: {
    methodKind: "unary";
    input: typeof GetStripePortalUrlRequestSchema;
    output: typeof GetStripePortalUrlResponseSchema;
  },
  /**
   * Clears a topup payment failure for an organization.
   *
   * Use this method to:
   * - Acknowledge and clear a failed topup payment
   * - Allow the UI to return to normal state after user acknowledges the failure
   *
   * Unlike subscription failures which auto-resolve when payment succeeds,
   * topup failures need explicit user acknowledgment because the commit was
   * voided by Metronome and the user needs to retry with a working payment method.
   *
   * @generated from rpc gitpod.v1.BillingService.ClearTopupFailure
   */
  clearTopupFailure: {
    methodKind: "unary";
    input: typeof ClearTopupFailureRequestSchema;
    output: typeof ClearTopupFailureResponseSchema;
  },
  /**
   * Returns daily credit consumption (OCU) time series for an organization,
   * broken down by metric category.
   *
   * @generated from rpc gitpod.v1.BillingService.GetCreditConsumptionTimeSeries
   */
  getCreditConsumptionTimeSeries: {
    methodKind: "unary";
    input: typeof GetCreditConsumptionTimeSeriesRequestSchema;
    output: typeof GetCreditConsumptionTimeSeriesResponseSchema;
  },
  /**
   * Sets up enterprise billing for an organization.
   *
   * Creates a Stripe customer, subscribes to the enterprise pricing plan,
   * and updates the billing realm. Idempotent — safe to retry on failure.
   *
   * Requires the 'change_billing_realm' account permission.
   *
   * ### Examples
   *
   * - Setup enterprise billing (production):
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   email: "billing@example.com"
   *   ```
   *
   * - Setup enterprise billing (sandbox):
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   sandbox: true
   *   ```
   *
   * @generated from rpc gitpod.v1.BillingService.SetupEnterpriseBilling
   */
  setupEnterpriseBilling: {
    methodKind: "unary";
    input: typeof SetupEnterpriseBillingRequestSchema;
    output: typeof SetupEnterpriseBillingResponseSchema;
  },
  /**
   * Updates auto-topup settings for an organization.
   *
   * Use this method to:
   * - Enable or disable automatic credit top-ups
   * - Configure the top-up amount and threshold
   * - Set a daily safety cap on automatic top-ups
   *
   * Requires Core tier and the auto-topup feature flag.
   *
   * @generated from rpc gitpod.v1.BillingService.UpdateAutoTopupSettings
   */
  updateAutoTopupSettings: {
    methodKind: "unary";
    input: typeof UpdateAutoTopupSettingsRequestSchema;
    output: typeof UpdateAutoTopupSettingsResponseSchema;
  },
  /**
   * Retrieves auto-topup settings for an organization.
   *
   * @generated from rpc gitpod.v1.BillingService.GetAutoTopupSettings
   */
  getAutoTopupSettings: {
    methodKind: "unary";
    input: typeof GetAutoTopupSettingsRequestSchema;
    output: typeof GetAutoTopupSettingsResponseSchema;
  },
  /**
   * Returns a daily credit usage report for an enterprise organization,
   * broken down by usage type and by user.
   *
   * @generated from rpc gitpod.v1.BillingService.GetCreditUsageReport
   */
  getCreditUsageReport: {
    methodKind: "unary";
    input: typeof GetCreditUsageReportRequestSchema;
    output: typeof GetCreditUsageReportResponseSchema;
  },
  /**
   * Returns a signed download URL for a CSV export of per-user credit usage.
   * The URL points to an HTTP endpoint that streams gzip-compressed CSV.
   *
   * @generated from rpc gitpod.v1.BillingService.GetCreditUsageExport
   */
  getCreditUsageExport: {
    methodKind: "unary";
    input: typeof GetCreditUsageExportRequestSchema;
    output: typeof GetCreditUsageExportResponseSchema;
  },
  /**
   * Corrects previously-synced usage events by cancelling the originals and
   * creating compensating negative-value events that flow through the normal
   * sync pipeline to Stripe. Internal admin operation.
   *
   * @generated from rpc gitpod.v1.BillingService.CorrectUsageEvents
   */
  correctUsageEvents: {
    methodKind: "unary";
    input: typeof CorrectUsageEventsRequestSchema;
    output: typeof CorrectUsageEventsResponseSchema;
  },
  /**
   * Inserts usage events from an external source (e.g., backfilling missing
   * LLM token usage from a provider console export). Internal admin operation.
   *
   * @generated from rpc gitpod.v1.BillingService.InsertUsageEvents
   */
  insertUsageEvents: {
    methodKind: "unary";
    input: typeof InsertUsageEventsRequestSchema;
    output: typeof InsertUsageEventsResponseSchema;
  },
  /**
   * Corrects environment_usage events for the given environment/time-range pairs.
   * Each EnvironmentCorrectionSpec identifies an environment and the window of
   * events to correct. Supports dry-run mode. Internal admin operation.
   *
   * @generated from rpc gitpod.v1.BillingService.CorrectEnvironmentUsageEvents
   */
  correctEnvironmentUsageEvents: {
    methodKind: "unary";
    input: typeof CorrectEnvironmentUsageEventsRequestSchema;
    output: typeof CorrectEnvironmentUsageEventsResponseSchema;
  },
  /**
   * Returns enterprise billing info for an organization.
   *
   * @generated from rpc gitpod.v1.BillingService.GetEnterpriseBillingInfo
   */
  getEnterpriseBillingInfo: {
    methodKind: "unary";
    input: typeof GetEnterpriseBillingInfoRequestSchema;
    output: typeof GetEnterpriseBillingInfoResponseSchema;
  },
  /**
   * Requests a one-time recovery credit grant for an organization that is out of credits.
   * Grants a small amount of free credits so the user can start an environment and push
   * uncommitted work. Can only be used once per organization.
   *
   * @generated from rpc gitpod.v1.BillingService.RequestRecoveryCredit
   */
  requestRecoveryCredit: {
    methodKind: "unary";
    input: typeof RequestRecoveryCreditRequestSchema;
    output: typeof RequestRecoveryCreditResponseSchema;
  },
  /**
   * Returns cumulative credit usage for an organization and its teams.
   *
   * Use this method to:
   * - Get the total cumulative credit consumption as of a point in time
   * - Get per-team cumulative usage with credit allocation (budget) comparison
   * - Display team credit summaries on the usage page and team detail page
   *
   * ### Examples
   *
   * - Get current cumulative usage:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * - Get cumulative usage as of a specific date:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   asOf: "2026-03-31T23:59:59Z"
   *   ```
   *
   * ### Authorization
   *
   * Requires `billing:read_usage` permission on the organization.
   *
   * @generated from rpc gitpod.v1.BillingService.GetCumulativeCreditUsage
   */
  getCumulativeCreditUsage: {
    methodKind: "unary";
    input: typeof GetCumulativeCreditUsageRequestSchema;
    output: typeof GetCumulativeCreditUsageResponseSchema;
  },
  /**
   * Creates a credit allocation (budget) for a team.
   *
   * Allocations are soft budgets for reporting and alerting — not enforced at usage time.
   * Over-allocation (sum of team budgets > org grant) is allowed.
   *
   * ### Examples
   *
   * - Create a team allocation:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   creditBudget: "500"
   *   ```
   *
   * ### Authorization
   *
   * Requires `billing:create` permission on the organization.
   *
   * @generated from rpc gitpod.v1.BillingService.CreateTeamCreditAllocation
   */
  createTeamCreditAllocation: {
    methodKind: "unary";
    input: typeof CreateTeamCreditAllocationRequestSchema;
    output: typeof CreateTeamCreditAllocationResponseSchema;
  },
  /**
   * Gets the credit allocation for a team.
   *
   * ### Examples
   *
   * - Get a team's allocation:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * ### Authorization
   *
   * Requires `billing:read` permission on the organization.
   *
   * @generated from rpc gitpod.v1.BillingService.GetTeamCreditAllocation
   */
  getTeamCreditAllocation: {
    methodKind: "unary";
    input: typeof GetTeamCreditAllocationRequestSchema;
    output: typeof GetTeamCreditAllocationResponseSchema;
  },
  /**
   * Updates the credit allocation for a team.
   *
   * ### Examples
   *
   * - Update a team's budget:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   creditBudget: "750"
   *   ```
   *
   * ### Authorization
   *
   * Requires `billing:update` permission on the organization.
   *
   * @generated from rpc gitpod.v1.BillingService.UpdateTeamCreditAllocation
   */
  updateTeamCreditAllocation: {
    methodKind: "unary";
    input: typeof UpdateTeamCreditAllocationRequestSchema;
    output: typeof UpdateTeamCreditAllocationResponseSchema;
  },
  /**
   * Deletes the credit allocation for a team.
   *
   * ### Examples
   *
   * - Delete a team's allocation:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   teamId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * ### Authorization
   *
   * Requires `billing:delete` permission on the organization.
   *
   * @generated from rpc gitpod.v1.BillingService.DeleteTeamCreditAllocation
   */
  deleteTeamCreditAllocation: {
    methodKind: "unary";
    input: typeof DeleteTeamCreditAllocationRequestSchema;
    output: typeof DeleteTeamCreditAllocationResponseSchema;
  },
  /**
   * Sets the contracted credit grant for an organization.
   *
   * This is an admin-only operation for setting the total credit budget
   * allocated to an enterprise organization under their contract.
   *
   * ### Examples
   *
   * - Set credit grant:
   *
   *   ```yaml
   *   organizationId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   creditGrant: "10000"
   *   ```
   *
   * ### Authorization
   *
   * Requires `change_billing_realm` account permission.
   *
   * @generated from rpc gitpod.v1.BillingService.SetOrganizationCreditGrant
   */
  setOrganizationCreditGrant: {
    methodKind: "unary";
    input: typeof SetOrganizationCreditGrantRequestSchema;
    output: typeof SetOrganizationCreditGrantResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_billing, 0);

